import React, { useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Modal, Offcanvas, Pagination, Tooltip, ProgressBar } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./mycreatedpolls.scss";
import axios from "axios";
import { ALCHEMY_API_KEY, api_url, IS_DISTRIBUTING_POINT_OPEN, rain_twitter_url, usdr_token } from "../../utils/Enviroment";
import useWeb3 from "../../hooks/useWeb3";
// import { useWeb3React } from "@web3-react/core";
import Loader from "../../hooks/loader";
import WinnerCheck from "../../hooks/dataFetcher/WinnerCheck";
import PercentageOptions from "../../hooks/dataFetcher/PercentageOptions";
import useSocket from "../SocketIo";
import LoaderTable from "../../hooks/loaderTable";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useSetRecoilState, useRecoilState } from "recoil";
import { userSmartAccountUsdtBalance, userSmartAccount, userSmartAccountClient, userTotalRewardPoints, userProfileData, userPublicClient } from "../RecoilAtom";
import { QRCodeCanvas } from 'qrcode.react';
import { TOKEN_ETH, TOKEN_USDT, TOKEN_USDR, QR_CODE_SIZE, USDT_LOGO_SIZE, INVITE, REFERRAL_POINTS, DEPOSIT, WITHDRAW, PERCENTAGE_OF_POINTS, getPointsRatio, FOLLOW_TWITTER, TWITTER_POINTS, TWITTER_VALUE, USDT_MOCK_VALUE, NETWORK_FEES, getPointsTitle, TOKEN_RAIN, getTokenLabel } from "../../utils/constants";
import { DepositViaWalletOrAddress, DepositViaAddress, DepositViaAccount, DepositSuccess } from "../Deposit"
import { useTransfer } from "../../hooks/dataSender/Transfer";
import { getDepositTokenConfig, handleDeposit, handleCopy, handleToFixedOnDecimals, handleToastErrors, isEthereumWalletAddress, formatDates, formatTimeTo12Hour, getFormatedWeb3Address, validateLink, handleGasFeeWithBuffer, sendGasFeeAsUsdt, formatNumbers, handleCheckSession, convertFromWei, getTokenSymbol, isSolvencyGateError, checkSolvencyGateViaPreview } from "../../utils/helpers";
import { useWithdrawalAmountHook } from '../../hooks/dataSender/WithdrawalAmount'
import { useConvertDeposit } from "../../hooks/dataSender/ConvertDeposit";
import { useConvertWithdraw, InsufficientUsdrError } from "../../hooks/dataSender/ConvertWithdraw";
import useBalance from "../../hooks/dataFetcher/BalanceOf";
import { IS_USDT_CONVERSION_ENABLED, CONVERTER_CAPACITY_MESSAGE, CONVERTER_RESERVE_HEADING, CONVERTER_RESERVE_MESSAGE, isConverterCapacityError, isConverterReserveError } from "../../utils/usdrConverter";
import { useGetAllBalances } from "../AllBalances";
import { encodeFunctionData } from "viem";
import TradePoolAbi from '../../utils/TradePoolAbi.json'
import { signPreparedCalls } from "@account-kit/wallet-client";
import { ethToDollarConverter, getUserPoints, postUserReferralPoints, postUserRewardPoints } from "../../utils/services";
import { useSessionPermissions } from "../../hooks/checkSessionPermissions";
import { getUsersProfile } from "../../utils/services";
import { Network, Alchemy } from 'alchemy-sdk';
import ProgressiveProgressBar from "../ProgressiveProgressBar";
import { notifyError, notifySuccess, notifyWarning } from "../Toast";
import { DEFAULT_ERROR_HEADING, GAS_FEES_ERROR, MARKET_CLOSE_WARNING, PROFILE_UPDATE_SUCCESS } from "../../utils/ConstantMessages";
import SolvencyLimitModal from "../SolvencyLimitModal/SolvencyLimitModal";
import { useEoaAccount } from "../../hooks/useEoaAccount";
import { detailPath } from "../../constants/Routes";

const PointsBreakdown = () => {
    const { pools, investments, setInvestMents, setPools } = useSocket();
    const { t } = useTranslation();
    const [startProgressBar, setStartProgressBar] = useState(false);
    const [show3, setShow3] = useState(false);
    const [loader, setLoader] = useState(false);
    const handleClose3 = () => setShow3(false);
    const handleShow3 = async (address, option) => {
        if (USDT_MOCK_VALUE > +smartAccountUsdtBalance) {
            notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
            return;
        }
        const callArgs = [
            {
                to: address,
                data: encodeFunctionData({
                    abi: TradePoolAbi,
                    functionName: 'chooseWinner',
                    args: [option]
                }),
            },
            {
                to: usdr_token,
                data: sendGasFeeAsUsdt(USDT_MOCK_VALUE)
            }
        ]
        const gasFee = await handleGasFeeWithBuffer(smartAccount, callArgs, alchemy)
        setGasEstimateInUsdt(gasFee)
        setShow3(true)
    };
    const web3 = useWeb3();
    const { account } = useEoaAccount();
    const [show6, setShow6] = useState(false);
    const [activeKey, setActiveKey] = useState("Points");
    const handleClose6 = async () => {
        setShow6(false);
        await getPoolsByCreator(1, "privatePools");
        await getMyInvestments();
    };
    const handleShow6 = () => setShow6(true);
    const [show5, setShow5] = useState(false);
    const handleClose5 = async () => {
        setShow5(false);
        await getPoolsByCreator(1, "privatePools");
        await getMyInvestments();
    };
    const handleShow5 = () => setShow5(true);
    const [userprofile, setUserProfile] = useRecoilState(userProfileData);
    const [perpoolPnl, setPerPoolPnl] = useState([]);
    const [totalpnl, setTotalPnl] = useState([]);
    const [name, setName] = useState("");
    const [twitterUrl, setTwitterUrl] = useState("");
    const [telegramUrl, setTelegramUrl] = useState("");
    const [withdrawalAddress, setWithdrawalAddress] = useState("");
    const [withdrawalAmount, setWithdrawalAmount] = useState("");
    const [DiscordUrl, setDiscordUrl] = useState("");
    const [profilepic, setProfilePic] = useState("");
    const smartAccountClient = useRecoilValue(userSmartAccountClient)
    const [publicpools, setPublicPools] = useState([]);
    const { withdrawalAmountTransaction } = useWithdrawalAmountHook();
    const { WinnerCheckHook } = WinnerCheck();
    const [loadertable, setLoaderTable] = useState(false);
    const accessToken = localStorage.getItem("accessToken");
    const [isCopied, setIsCopied] = useState(false);
    const [isReferralCopied, setIsReferralCopied] = useState(false);
    const [poolsdetail, setPoolsDetail] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null); // State to track the selected option
    const [selectedname, setSelectedName] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(3); // Set a default value of pages
    const [totalCount, setTotalCount] = useState(0);
    const [winnercheck, setWinnerCheck] = useState(0);
    const [message, setMessage] = useState("");
    const [show1, setShow1] = useState(false);
    const handleClose1 = () => setShow1(false);
    const handleShow1 = () => setShow1(true);
    const [show7, setShow7] = useState(false);
    const handleClose7 = () => setShow7(false);
    const handleShow7 = () => setShow7(true);
    const [show8, setShow8] = useState(false);
    const handleClose8 = () => setShow8(false);
    const handleShow8 = () => setShow8(true);
    const [show9, setShow9] = useState(false);
    const handleClose9 = () => setShow9(false);
    const handleShow9 = () => setShow9(true);
    const { PercentageOptionsHook } = PercentageOptions();
    const [percentageoption, setPercentageOption] = useState("");
    const [percentageindiv, setPercentageIndivi] = useState("");
    const [totalprediction, setTotalPrediction] = useState("");
    const [withdrawalToken, setWithdrawalToken] = useState(TOKEN_USDR);
    const [withdrawalRequest, setWithdrawalRequest] = useState(false);
    const [withdrawalTokenImage, setWithdrawalTokenImage] = useState("/assets/poll/usdr.svg");
    const [portfolioAmount, setPortfolioAmount] = useState("");
    const api_key = "2318bd9b1ee9b9a732ca";
    const secret_key = "78029869855f6acdef83f4ad97ae6b5a0a1afae8146ee9a086394ae612810731";
    const smartAccount = useRecoilValue(userSmartAccount);
    const publicClient = useRecoilValue(userPublicClient);
    const [showSolvencyModal, setShowSolvencyModal] = useState(false);
    const transferFunds = useTransfer()
    const convertAndDeposit = useConvertDeposit()
    const convertAndWithdraw = useConvertWithdraw()
    const { getTokenBalance } = useBalance();
    const [selectedToken, setSelectedToken] = useState(TOKEN_USDR);
    const [depositAmount, setDepositAmount] = useState("");
    const [showFundAccount, setShowFundAccount] = useState(false);
    const [showDepositAccOrAddr, setShowDepositAccOrAddr] = useState(false);
    const [showDepositViaAddress, setShowDepositViaAddress] = useState(false);
    const [showDepositViaAccount, setShowDepositViaAccount] = useState(false);
    const [showDepositSuccess, setShowDepositSuccess] = useState(false);
    const [isDepositing, setIsDepositing] = useState(false);
    const [showWithdraw, setShowWithdraw] = useState(false);
    const handleCloseWithdraw = () => setShowWithdraw(false);
    const handleShowWithdraw = () => setShowWithdraw(() => {
        if (account) {
            setShowWithdraw(true)
        }
        else { handleToastErrors("Please connect your wallet"); }
    });
    const getAllBalances = useGetAllBalances();
    const [showComplete, setShowComplete] = useState(false);
    const handleCloseComplete = () => { setShowComplete(false); setWithdrawalAddress(""); setWithdrawalAmount(""); getAllBalances() };
    const handleShowComplete = () => setShowComplete(true);
    const [showFailed, setShowFailed] = useState(false);
    const handleCloseFailed = () => setShowFailed(false);
    const handleShowFailed = () => setShowFailed(true);
    const [depositBalance, setDepositBalance] = useState();
    const smartAccountUsdtBalance = useRecoilValue(userSmartAccountUsdtBalance);
    const setSmartAccountUsdtBalance = useSetRecoilState(userSmartAccountUsdtBalance);
    const [activeWithdrawalBalance, setActiveWithdrawalBalance] = useState();
    const [userTotalPoints, setUserTotalPoints] = useRecoilState(userTotalRewardPoints);
    const [pointsHistory, setPointsHistory] = useState([]);
    const baseUrl = `${window.location.origin}`;
    const completeReferralLink = `${baseUrl}?code=${smartAccount}`
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const { grantPermissions } = useSessionPermissions()
    const [gasEstimateInUsdt, setGasEstimateInUsdt] = useState("")
    const settings = {
        apiKey: ALCHEMY_API_KEY,
        network: Network.ARB_MAINNET,
    };
    const alchemy = new Alchemy(settings);

    const getUserPointsHistory = async () => {
        try {
            const pointsHistory = await getUserPoints();
            setUserTotalPoints(pointsHistory?.totalPoints);
            setPointsHistory(pointsHistory?.history);
        } catch (error) {
            console.error("Error fetching user points history:", error);
        }
    }

    useEffect(() => {
        if (account && smartAccount && accessToken) {
            (async () => {
                await getAllBalances();
                await getUsersProfile();
                await getTotalPnl()
                await getTotalPredictions()
                await getMyInvestments()
            })();
        }
    }, [account, smartAccount, accessToken]);

    useEffect(() => {
        if (account && smartAccount) {
            (async () => {
                setPortfolioAmount(smartAccountUsdtBalance);
                setActiveWithdrawalBalance(smartAccountUsdtBalance)
            })();
        }
        else {
            setPortfolioAmount("");
            setSmartAccountUsdtBalance("")
        }
    }, [smartAccount, smartAccountUsdtBalance]);

    useEffect(() => {
        if (!account) return;
        (async () => {
            try {
                const { tokenAddress, tokenDecimals } = getDepositTokenConfig(selectedToken);
                setDepositBalance(await getTokenBalance(tokenAddress, account, tokenDecimals));
            } catch (error) {
                console.error("Failed to fetch deposit balance:", error);
            }
        })();
    }, [selectedToken, account]);

    const depositUsdtOrEth = async () => {
        const depositData = await handleDeposit({
            transferFunction: selectedToken === TOKEN_USDT ? convertAndDeposit : transferFunds,
            amount: depositAmount,
            tokenConfig: getDepositTokenConfig(selectedToken),
            balance: depositBalance,
            toAddress: smartAccount,
            setIsLoading: setIsDepositing,
            onSuccess: () => {
                setShowDepositSuccess(true);
                setShowDepositViaAccount(false);
                setShowDepositAccOrAddr(false);
            },
            onError: (err) => console.log("Custom error handler:", err)
        });
        if (depositData && userprofile?.referredBy && !userprofile?.isSuccessfullyOnboarded && IS_DISTRIBUTING_POINT_OPEN) {
            const payload = {
                eventType: INVITE,
                value: "0",
                points: REFERRAL_POINTS
            }
            await postUserReferralPoints(payload)
            await getUserPointsHistory()
        }
        if (depositData && IS_DISTRIBUTING_POINT_OPEN) {
            const ethPriceInUsdt = await ethToDollarConverter();
            const depositAmountInUsdt = selectedToken === TOKEN_ETH ? +depositAmount * ethPriceInUsdt : depositAmount;
            const depositPoints = (+depositAmountInUsdt * PERCENTAGE_OF_POINTS) * 100;
            const payload = {
                eventType: DEPOSIT,
                value: depositAmountInUsdt,
                points: depositPoints,
                transactionHash: depositData?.transactionHash,
            }
            await postUserRewardPoints(payload)
            await getUserPointsHistory()

        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const fileType = file.type;
            if (fileType !== "image/png" && fileType !== "image/jpeg") {
                notifyError(DEFAULT_ERROR_HEADING, t("Please upload a PNG or JPG image."));
                return;
            }
            const reader = new FileReader();
            reader.onload = () => {
                setProfilePic(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleOptionClick = (optionindex, name) => {
        setSelectedOption(optionindex); // Update the state with the selected option's ID
        setSelectedName(name);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page); // Update currentPage when a page is clicked
    };

    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const getPoolsByCreator = async (offset = 1, type = "publicPools") => {
        setLoaderTable(true);
        try {
            const params = {
                offset,
                limit: 10,
                filter: type, // Default to 'publicPools' if no type is provided
            };

            const response = await axios.get(
                `${api_url}/pools/pool-listing-by-creator`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "application/json",
                    },
                    params: params,
                }
            );

            setTotalCount(response.data.data.count);
            setTotalPages(response.data.data.pages);
            setPublicPools(response.data.data.pools);
            setPools(response.data.data.pools);
            setLoaderTable(false);
        } catch (error) {
            console.error("Error fetching pools:", error);
            setLoaderTable(false);
        }
    };

    // const handleSelect = (key) => {
    //     setActiveKey(key);
    //     const filterType = key === 'Public Polls' ? 'publicPools' : 'privatePools';
    //     getPoolsByCreator(1, filterType);
    // };
    const handleSelect = (key) => {
        setActiveKey(key);
        setCurrentPage(1); // Reset page when changing tabs
    };
    // const totalPages = 15;

    // const handlePageChange = (page) => {
    //     setCurrentPage(page);
    // };

    // const handlePrev = () => {
    //     if (currentPage > 1) {
    //         setCurrentPage(currentPage - 1);
    //     }
    // };

    // const handleNext = () => {
    //     if (currentPage < totalPages) {
    //         setCurrentPage(currentPage + 1);
    //     }
    // };

    const getPercentagesOption = async (address) => {
        try {
            const selectedChoiceIndexes = pools?.options?.map((option) =>
                option.choiceIndex.toString()
            );
            const response = await PercentageOptionsHook(
                address,
                selectedChoiceIndexes
            );
            if (Array.isArray(response) && response.length > 0) {
                const individualTotalSupplyLP = [];
                const totalSupplyLPSum = response.reduce((sum, entry) => {
                    const currentTotalSupplyLP = parseFloat(entry.percentageOption || 0);
                    individualTotalSupplyLP.push(currentTotalSupplyLP);
                    return sum + currentTotalSupplyLP;
                }, 0);
                setPercentageOption(totalSupplyLPSum);
                setPercentageIndivi(individualTotalSupplyLP);
            } else {
                setPercentageOption(0);
                setPercentageIndivi(0);
            }
        } catch (error) {
            console.error("Failed to fetch percentages:", error.message || error);
            setPercentageOption(0);
            setPercentageIndivi(0);
        }
    };

    useEffect(() => {
        if (pools) {
            getPercentagesOption();
        }
    }, [web3, pools]);

    useEffect(() => {
        window.scrollTo(0, 0);
        getUserPointsHistory()
    }, []);

    const getMyInvestments = async (offset = 1) => {
        setLoaderTable(true);
        try {
            const response = await axios.get(
                `${api_url}/investments/user-invested-pools`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "multipart/form-data",
                    },
                    params: {
                        offset,
                        limit: 10,
                    },
                }
            );
            setInvestMents(response.data.data);
            setTotalCount(response.data.data.total);
            setTotalPages(response.data.data.pages);
            setLoaderTable(false);
        } catch (error) {
            console.error("Error fetching pools:", error);
            setLoaderTable(false);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            if (activeKey === "Investment Polls") {
                await getMyInvestments(currentPage);
            } else if (activeKey === "Public Polls") {
                await getPoolsByCreator(currentPage, "publicPools");
            } else if (activeKey === "Private Polls") {
                await getPoolsByCreator(currentPage, "privatePools");
            }
        };

        fetchData();
    }, [currentPage, activeKey]);

    const [copiedStates, setCopiedStates] = useState({
        accessCode: false,
        address: false,
        id: false,
    });

    const handleCopyClick = (type, value, index) => {
        navigator?.clipboard?.writeText(value).then(() => {
            setCopiedStates((prevState) => ({
                ...prevState,
                [type]: true,
                index,
            }));

            setTimeout(() => {
                setCopiedStates((prevState) => ({
                    ...prevState,
                    [type]: false,
                }));
            }, 1000);
        });
    };
    const handleCopyClick11 = (text, isSmartAccount) => {
        const textToCopy = text;
        const tempTextArea = document.createElement("textarea");
        tempTextArea.value = textToCopy;
        document.body.appendChild(tempTextArea);
        tempTextArea.select();
        document.execCommand("copy");
        document.body.removeChild(tempTextArea);
        if (isSmartAccount) {
            setIsCopied(true);
            setTimeout(() => {
                setIsCopied(false);
            }, 1000);
        } else {
            setIsReferralCopied(true);
            setTimeout(() => {
                setIsReferralCopied(false);
            }, 1000);
        }


    };

    const getTotalPredictions = async () => {
        try {
            const url = `${api_url}/pools/total-predictions-by-user`;
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            setTotalPrediction(response?.data?.data?.totalPoolsInvested);
        } catch (error) {
            console.error("Error fetching pools:", error);
        }
    };
    useEffect(() => {
        getTotalPredictions();
    }, []);

    const getPoolsById = async (id, owner) => {
        if (smartAccount?.toLowerCase() != owner) {
            notifyError(DEFAULT_ERROR_HEADING, t("Only the market creator can perform this action."));
            return;
        }
        try {
            const url = `${api_url}/pools/pool/${id}`;
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            setPoolsDetail(response?.data?.data);
            handleShow3(response?.data?.data?.contractAddress, 1);
        } catch (error) {
            console.error("Error fetching pools:", error);
        }
    };

    useEffect(() => {
        let isMounted = true;
        const WinnersCheck = async () => {
            try {
                const address = poolsdetail?.contractAddress;
                if (address) {
                    const res = await WinnerCheckHook(address);
                    if (isMounted) {
                        setWinnerCheck(res);
                    }
                }
            } catch (error) {
                console.error("Failed to fetch balance.");
            }
        };
        WinnersCheck();
        return () => {
            isMounted = false;
        };
    }, [poolsdetail?.contractAddress]);
    const handleContinue = async (address) => {
        const currentTimestamp = Math.floor(Date.now() / 1000);

        if (!selectedOption) {
            notifyError(DEFAULT_ERROR_HEADING, t("Please select an option.."));
            return;
        }

        if (!account) {
            notifyError(DEFAULT_ERROR_HEADING, "Connect Wallet!");
            return;
        }

        if (+gasEstimateInUsdt > +smartAccountUsdtBalance) {
            notifyError(DEFAULT_ERROR_HEADING, "Insufficient balance to resolve market");
            return;
        }
        setStartProgressBar(true);
        handleClose3();
        handleShow7();
        const isSessionExists = await handleCheckSession()
        setMessage(isSessionExists ? 'Confirm the transaction in your wallet' : "Deciding Winner....");
        try {
            const { userPermissions: permissions, userSessionKey: sessionKey } = await grantPermissions()
            setMessage("Deciding Winner....");

            const callArgs = [
                {
                    to: address,
                    data: encodeFunctionData({
                        abi: TradePoolAbi,
                        functionName: 'chooseWinner',
                        args: [selectedOption]
                    }),
                },
                {
                    to: usdr_token,
                    data: sendGasFeeAsUsdt(gasEstimateInUsdt)
                }
            ]
            const preparedCalls = await smartAccountClient.prepareCalls({
                calls: callArgs,
                from: smartAccount,
                capabilities: {
                    permissions,
                },
            });
            const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
            const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
                ...signedCalls,
                capabilities: {
                    permissions,
                },
            });
            const transactionResponse = await smartAccountClient.getCallsStatus(preparedCallIds[0]);

            if (transactionResponse) {
                setStartProgressBar(false);
                setTimeout(() => {
                    handleClose7();
                    handleShow5();
                    setMessage("");
                }, 3000);
                return transactionResponse;
            }

        } catch (error) {
            if (error.status === 401) {
                notifyError(DEFAULT_ERROR_HEADING,
                    t("Session expired. Please log in again.")
                );
            } else {
                notifyError(DEFAULT_ERROR_HEADING, t("Transaction denied"));
            }
            setStartProgressBar(false);
            handleClose7();
            setMessage("");
        }
    };

    const ClosePoolHandle = async (address, finalized) => {
        if (USDT_MOCK_VALUE > +smartAccountUsdtBalance) {
            notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
            return;
        }
        setStartProgressBar(true);
        handleShow7();
        try {
            const accessToken = localStorage.getItem("accessToken");
            const tokenCheckRes = await fetch(
                `${api_url}/users/check-token-expiration?token=${accessToken}`,
                {
                    method: "GET",
                }
            );
            const tokenCheckData = await tokenCheckRes.json();
            if (!tokenCheckRes.ok || tokenCheckData.isExpired) {
                setLoader(false);
                setMessage("");
                notifyError(DEFAULT_ERROR_HEADING, t("Session expired. Please log in again"));
                return;
            }
            const isSessionExists = await handleCheckSession()
            setMessage(isSessionExists ? 'Confirm the transaction in your wallet' : "Closing Market...");
            if (!finalized) {
                const { userPermissions: permissions, userSessionKey: sessionKey } = await grantPermissions()
                setMessage("Closing Market...");
                const callArgs = [
                    {
                        to: address,
                        data: encodeFunctionData({
                            abi: TradePoolAbi,
                            functionName: 'closePool',
                        }),
                    },
                    {
                        to: usdr_token,
                        data: sendGasFeeAsUsdt(USDT_MOCK_VALUE)
                    }
                ]
                const gasFee = await handleGasFeeWithBuffer(smartAccount, callArgs, alchemy)
                if (+gasFee > +smartAccountUsdtBalance) {
                    notifyError(DEFAULT_ERROR_HEADING, t(`Insufficient balance Need $${gasFee} to close the Market`));
                    return;
                }
                const callArgsWithGasFees = [
                    {
                        to: address,
                        data: encodeFunctionData({
                            abi: TradePoolAbi,
                            functionName: 'closePool',
                        }),
                    },
                    {
                        to: usdr_token,
                        data: sendGasFeeAsUsdt(gasFee)
                    }
                ]
                const preparedCalls = await smartAccountClient.prepareCalls({
                    calls: callArgsWithGasFees,
                    from: smartAccount,
                    capabilities: {
                        permissions,
                    },
                });
                const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
                const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
                    ...signedCalls,
                    capabilities: {
                        permissions,
                    },
                });
                const transactionResponse = await smartAccountClient.getCallsStatus(preparedCallIds[0]);
                if (transactionResponse) {
                    setStartProgressBar(false);
                    setTimeout(() => {
                        handleClose7();
                        handleShow6();
                        setMessage("");
                    }, 3000);
                }
                return transactionResponse;
            }
            else {
                notifyWarning(MARKET_CLOSE_WARNING);
                setStartProgressBar(false);
                handleClose7();
            }
        } catch (error) {
            setStartProgressBar(false);
            handleClose7();
            setMessage("");
            notifyError(DEFAULT_ERROR_HEADING, t("An error occurred while closing the Market."));
        }
    };

    const handleUpdateProfile = async () => {
        setLoader(true);
        try {
            const currentProfile = userprofile
            const payload = {};
            if (name !== undefined && name !== currentProfile?.name) {
                payload.name = name;
            }
            if (profilepic && profilepic !== currentProfile?.profilePic) {
                try {
                    const base64Data = profilepic.split(",")[1];
                    const byteCharacters = atob(base64Data);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: "image/png" });
                    const formData = new FormData();
                    formData.append("file", blob, "profile.png");
                    const res = await fetch(
                        "https://api.pinata.cloud/pinning/pinFileToIPFS",
                        {
                            method: "POST",
                            headers: {
                                pinata_api_key: `${api_key}`,
                                pinata_secret_api_key: `${secret_key}`,
                            },
                            body: formData,
                        }
                    );
                    const pinataResponse = await res.json();
                    if (pinataResponse.IpfsHash) {
                        payload.profilePic = `https://gateway.pinata.cloud/ipfs/${pinataResponse.IpfsHash}`;
                    } else {
                        throw new Error("IPFS upload failed");
                    }
                } catch (pinataError) {
                    console.error("Error uploading to Pinata:", pinataError);
                    setLoader(false);
                    return;
                }
            }

            if (twitterUrl !== currentProfile?.twitterLink) {
                if (twitterUrl === "") {
                    payload.twitterLink = "";
                } else {
                    const validTwitter = validateLink(twitterUrl);
                    if (validTwitter) {
                        payload.twitterLink = validTwitter;
                    } else {
                        notifyError(DEFAULT_ERROR_HEADING, t("Please enter a valid X (Twitter) URL."));
                        setLoader(false);
                        return;
                    }
                }
            }

            if (telegramUrl !== currentProfile?.telegramLink) {
                if (telegramUrl === "") {
                    payload.telegramLink = "";
                } else {
                    const validTelegram = validateLink(telegramUrl);
                    if (validTelegram) {
                        payload.telegramLink = validTelegram;
                    } else {
                        notifyError(DEFAULT_ERROR_HEADING, t("Please enter a valid Telegram URL."));
                        setLoader(false);
                        return;
                    }
                }
            }

            if (DiscordUrl !== currentProfile?.discordLink) {
                if (DiscordUrl === "") {
                    payload.discordLink = "";
                } else {
                    const validDiscord = validateLink(DiscordUrl);
                    if (validDiscord) {
                        payload.discordLink = validDiscord;
                    } else {
                        notifyError(DEFAULT_ERROR_HEADING, t("Please enter a valid Discord URL."));
                        setLoader(false);
                        return;
                    }
                }
            }

            if (Object.keys(payload).length === 0) {
                notifyError(DEFAULT_ERROR_HEADING, t("No changes detected."));
                setLoader(false);
                return;
            }
            await axios.patch(`${api_url}/users/user-profile-update`, payload, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            notifySuccess(PROFILE_UPDATE_SUCCESS)
            const profileData = await getUsersProfile();
            setUserProfile(profileData?.data?.data)
            handleClose1();
        } catch (error) {
            notifyError(DEFAULT_ERROR_HEADING, t("Unable to save profile changes. Please try again."));
        } finally {
            setLoader(false);
        }
    };

    const getTotalPnl = async () => {
        try {
            const response = await axios.get(
                `${api_url}/investments/calculate-user-PNL`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            const data = response?.data?.data;
            const convertedData = {
                totalInvestment: convertFromWei(
                    data.totalInvestment,
                    "ether"
                ),
                totalClaimed: convertFromWei(data.totalClaimed, "ether"),
                pnl: convertFromWei(data.pnl, "ether"),
                // userId: data.userId, // Keep userId as is
            };
            setTotalPnl(convertedData);
        } catch (error) {
            console.error("Error fetching PNL data:", error);
        }
    };

    const getUsersProfileData = async () => {
        try {
            const response = await getUsersProfile()
            setUserProfile(response?.data?.data);
            setTelegramUrl(response?.data?.data?.telegramLink)
            setTwitterUrl(response?.data?.data?.twitterLink)
            setDiscordUrl(response?.data?.data?.discordLink)
            setName(response?.data?.data?.name);
        } catch (error) {
            console.error('error: ', error);
        }
    };

    useEffect(() => {
        getUsersProfileData();
        getTotalPnl();
    }, []);

    const getPerPoolPnl = async () => {
        try {
            const response = await axios.get(
                `${api_url}/investments/calculate-user-PNL-per-pool`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            setPerPoolPnl(response?.data?.data?.data || []);
        } catch (error) {
            console.log("An error occurred while updating profile.");
        }
    };

    useEffect(() => {
        getPerPoolPnl();
    }, []);

    const handleRemove = async () => {
        if (userprofile) {
            userprofile.profilePic = "/assets/placeholder.png";
        }
        try {
            const accessToken = localStorage.getItem("accessToken");

            const response = await fetch(`${api_url}/users/remove-user-profile-pic`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            const data = await response.json();
            setProfilePic(data.data.profilePic);
            getUsersProfile();
            handleClose1();
        } catch (error) {
            console.error("Error updating profile picture:", error);
            notifyError(DEFAULT_ERROR_HEADING, t("Something went wrong. Please try again."));
        }
    };

    const pnlValue = isNaN(parseFloat(totalpnl?.pnl))
        ? 0
        : parseFloat(totalpnl?.pnl).toFixed(2);
    const isProfit = pnlValue >= 0;
    const renderTooltip = (props) => {
        const totalInvestment = parseFloat(totalpnl?.totalInvestment) || 0;
        const totalClaimed = parseFloat(totalpnl?.totalClaimed) || 0;
        const pnl = totalClaimed - totalInvestment;
        return (
            <Tooltip id="pnltooltip" {...props}>
                <div className="multi-values">
                    <div className="single-value">
                        <p>{t("Total Invested")}</p>
                        <h6>${totalInvestment.toFixed(2)}</h6>
                    </div>

                    {pnl >= 0 ? (
                        <div className="single-value">
                            <p>Total Wins</p>
                            <h6>${pnl.toFixed(2)}</h6>
                        </div>
                    ) : (
                        <div className="single-value">
                            <p>Total Loss</p>
                            <h6>${Math.abs(pnl).toFixed(2)}</h6>
                        </div>
                    )}
                </div>
            </Tooltip>
        );
    };

    const handleWithdrawFunds = async () => {
        if (!withdrawalAddress) {
            notifyError(DEFAULT_ERROR_HEADING, 'Address is required!');
            return;
        }
        if (!isEthereumWalletAddress(withdrawalAddress)) {
            handleToastErrors('Invalid wallet address!');
            return;
        }

        if (!withdrawalAmount || (+withdrawalAmount <= 0)) {
            notifyError(DEFAULT_ERROR_HEADING, 'Please enter an amount.');
            return;
        }

        if ((+withdrawalAmount) > (+activeWithdrawalBalance)) {
            notifyError(DEFAULT_ERROR_HEADING, 'Amount cannot be Greater Than Balance!');
            return;
        }

        // USDR is paid out as USDT through the converter where one is configured
        const paysOutUsdt = withdrawalToken === TOKEN_USDR && IS_USDT_CONVERSION_ENABLED;

        try {
            setWithdrawalRequest(true);
            const { receipt, error } = paysOutUsdt
                ? await convertAndWithdraw(withdrawalAddress, withdrawalAmount)
                : await withdrawalAmountTransaction(withdrawalAddress, withdrawalAmount, withdrawalToken, smartAccountUsdtBalance);
            if (receipt && !error) {
                handleCloseWithdraw();
                handleShowComplete();
                if (IS_DISTRIBUTING_POINT_OPEN) {
                    const ethPriceInUsdt = await ethToDollarConverter();
                    const withdrawAmountInUsdt = withdrawalToken === TOKEN_ETH ? +withdrawalAmount * ethPriceInUsdt : withdrawalAmount;
                    const withdrawPoints = (+withdrawAmountInUsdt * PERCENTAGE_OF_POINTS) * 100;
                    const payload = {
                        eventType: WITHDRAW,
                        value: withdrawAmountInUsdt,
                        points: -withdrawPoints,
                        transactionHash: receipt?.transactionHash,
                    }
                    await postUserRewardPoints(payload)
                    await getUserPointsHistory()
                }
            }
            else {
                let isSolvency = isSolvencyGateError(error);
                if (!isSolvency && publicClient) {
                    try { isSolvency = await checkSolvencyGateViaPreview(publicClient, usdr_token); }
                    catch { /* fall through */ }
                }
                if (error?.info?.error?.code === 4001) {
                    notifyError(DEFAULT_ERROR_HEADING, "Transaction denied by user.");
                } else if (isSolvency) {
                    setShowSolvencyModal(true);
                } else if (error instanceof InsufficientUsdrError) {
                    notifyError("Your forecast is off", 'Try to make a smaller withdrawal.');
                } else if (isConverterReserveError(error)) {
                    notifyError(CONVERTER_RESERVE_HEADING, CONVERTER_RESERVE_MESSAGE);
                } else if (isConverterCapacityError(error)) {
                    notifyError(DEFAULT_ERROR_HEADING, CONVERTER_CAPACITY_MESSAGE);
                } else {
                    handleCloseWithdraw();
                    handleShowFailed();
                }
            }
        } catch (error) {
            console.error('Transaction error (handled):', error);
            let isSolvency = isSolvencyGateError(error);
            if (!isSolvency && publicClient) {
                try { isSolvency = await checkSolvencyGateViaPreview(publicClient, usdr_token); }
                catch { /* fall through */ }
            }
            if (isSolvency) {
                setShowSolvencyModal(true);
            } else {
                handleShowFailed();
            }
        }
        finally {
            setWithdrawalRequest(false);
        }
    };

    const selectionToken = (token, image, balance) => {
        setWithdrawalToken(token);
        setWithdrawalTokenImage(image);
        setActiveWithdrawalBalance(balance);
        setWithdrawalAmount("")
    }

    const scrollToHistory = async () => {
        const mainTabsContainer = document.querySelector(".tabsmain");
        if (mainTabsContainer) {
            mainTabsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        setShowDepositSuccess(false)
        setActiveKey("History");
        setDepositAmount("")
        await getAllBalances()
    }

    const getCopiedStatus = () => {
        handleCopy(smartAccount)
        setIsCopied(true)
        setTimeout(() => {
            setIsCopied(false);
        }, 1000);
    }

    const handleDepositClick = () => {
        if (account) {
            setShowDepositAccOrAddr(true);
        }
        else { handleToastErrors("Login to deposit!"); }
    };


    const FollowTwitter = async () => {
        window.open(rain_twitter_url, '_blank');
        await new Promise((resolve) => setTimeout(resolve, 5000));
        const payload = {
            eventType: FOLLOW_TWITTER,
            value: TWITTER_VALUE,
            points: TWITTER_POINTS,
        };
        await postUserRewardPoints(payload);
        await getUserPointsHistory();
        await getUsersProfileData();
    };

    const renderTooltipPoints = (props) => {
        return (
            <Tooltip id="pnltooltip" {...props}>
                <div className="pointsdata">
                    <p>RAIN Points reflect your economic contribution to the platform.</p>
                    <ul>
                        <li>Earn points by depositing funds, trading, adding liquidity, and inviting friends</li>
                        <li> Points increase your share in airdrops and Raindrops</li>
                    </ul>
                </div>
            </Tooltip>
        );
    };

    return (
        <>
            <DepositViaWalletOrAddress show={showDepositAccOrAddr} handleClose={() => setShowDepositAccOrAddr(false)} ShowDepositAddressModal={setShowDepositViaAddress} ShowDeposiAccountModal={setShowDepositViaAccount} smartAccount={smartAccount} />
            <DepositViaAddress
                show={showDepositViaAddress}
                handleClose={() => setShowDepositViaAddress(false)}
                QrCodeSize={QR_CODE_SIZE}
                QRCodeCanvas={QRCodeCanvas}
                smartAccount={smartAccount}
                UsdtLogoSize={USDT_LOGO_SIZE}
                isCopied={isCopied}
                handleCopy={getCopiedStatus}
                setSelectedToken={setSelectedToken}
                selectedToken={selectedToken}
            />
            <DepositViaAccount
                show={showDepositViaAccount}
                handleClose={() => setShowDepositViaAccount(false)}
                selectedBalance={depositBalance}
                setSelectedToken={setSelectedToken}
                selectedToken={selectedToken}
                DepositUsdtOrEth={depositUsdtOrEth}
                depositAmount={depositAmount}
                setDepositAmount={setDepositAmount}
                isDepositing={isDepositing}
            />
            <DepositSuccess
                show={showDepositSuccess}
                handleClose={() => { setShowDepositSuccess(false); setDepositAmount(""); getAllBalances() }}
                depositAmount={depositAmount}
                selectedToken={selectedToken}
                scrollToHistory={scrollToHistory}
            />
            {loader && <Loader text={message} />}
            <section className="mycreatedpolls pointsbreakdown-section">
                <div className="custom-container">
                    <div className="main-heading">
                        <h4>{t("Raindrops")}</h4>
                    </div>
                    <div className="profilemid">
                        <div className="inviteandearn">
                            <div className="upper-heading">
                                <h6>{t("Invite & Earn")}</h6>
                                <p>{t("You earn 1,000 Raindrops when a friend joins. They also earn 1,000 Raindrops!")}</p>
                            </div>
                            <div className="refferal-link">
                                <p><span>{t("Referral Link")}</span> {completeReferralLink?.slice(0, 35)}...</p>
                            </div>
                            <button onClick={() => handleCopyClick11(completeReferralLink, false)} className="btn-copy">
                                {isReferralCopied ? <p className="text-Black">{t("copied")}</p> : <>{t("COPY REFERRAL LINK")}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                                        <g clip-path="url(#clip0_2857_4162)">
                                            <path d="M12.167 4.66663H6.33366C5.68933 4.66663 5.16699 5.18896 5.16699 5.83329V11.6666C5.16699 12.311 5.68933 12.8333 6.33366 12.8333H12.167C12.8113 12.8333 13.3337 12.311 13.3337 11.6666V5.83329C13.3337 5.18896 12.8113 4.66663 12.167 4.66663Z" stroke="#111111" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M2.83366 9.33329C2.19199 9.33329 1.66699 8.80829 1.66699 8.16663V2.33329C1.66699 1.69163 2.19199 1.16663 2.83366 1.16663H8.66699C9.30866 1.16663 9.83366 1.69163 9.83366 2.33329" stroke="#111111" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_2857_4162">
                                                <rect width="14" height="14" fill="white" transform="translate(0.5)" />
                                            </clipPath>
                                        </defs>
                                    </svg></>}
                            </button>
                        </div>
                        <div className="inviteandearn">
                            <div className="upper-heading">
                                <h6>{t("Get Quick Raindrops")}</h6>
                                <p>{t("One-time bonus! Follow us on X to instantly earn +500 Raindrops.")}</p>
                            </div>
                            <div className="social-parent">
                                <div className="single-link">
                                    <div className="text">
                                        <h6>{t("Follow us on X")}</h6>
                                        <p>+{t("500 Raindrops")}</p>
                                    </div>
                                    {userprofile?.followedTwitter ? <div style={{ color: "var(--green-text)" }}>{t("Completed")}

                                    </div> : <a href="#" onClick={FollowTwitter}>{t("Follow & Confirm")}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                            <path d="M15.5855 9.39828L10.523 14.4608C10.4174 14.5663 10.2743 14.6256 10.125 14.6256C9.97573 14.6256 9.83258 14.5663 9.72703 14.4608C9.62148 14.3552 9.56219 14.2121 9.56219 14.0628C9.56219 13.9135 9.62148 13.7704 9.72703 13.6648L13.8298 9.56281L2.8125 9.56281C2.66332 9.56281 2.52024 9.50355 2.41475 9.39806C2.30926 9.29257 2.25 9.1495 2.25 9.00031C2.25 8.85113 2.30926 8.70805 2.41475 8.60257C2.52024 8.49708 2.66332 8.43781 2.8125 8.43781L13.8298 8.43781L9.72703 4.33578C9.62148 4.23023 9.56219 4.08708 9.56219 3.93781C9.56219 3.78855 9.62148 3.64539 9.72703 3.53984C9.83258 3.4343 9.97573 3.375 10.125 3.375C10.2743 3.375 10.4174 3.4343 10.523 3.53984L15.5855 8.60234C15.6378 8.65458 15.6793 8.71662 15.7076 8.78491C15.7359 8.8532 15.7504 8.92639 15.7504 9.00031C15.7504 9.07423 15.7359 9.14743 15.7076 9.21572C15.6793 9.284 15.6378 9.34604 15.5855 9.39828Z" fill="#E6FF00" />
                                        </svg>
                                    </a>}

                                </div>
                            </div>
                        </div>
                        <div className="innergraph">
                            <div className="upper-title">
                                <h4>{t("Raindrops")}</h4>
                                <p>{t("You can earn Raindrops by depositing funds, trading, adding liquidity, and inviting friends. More Raindrops mean greater share in a future $RAIN Airdrop.")}</p>
                            </div>
                            <div className="top-headings h-100">
                                <h6 className="innerheadtext">{t("My Raindrops")}</h6>
                                <div className="leftheadings">
                                    <h5 className="dollarhead" style={{ color: userTotalPoints > 0 ? "var(--green-text)" : "var(--logout-text)", margin: "0" }}>
                                        {userTotalPoints ? formatNumbers(userTotalPoints) : 0}
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="main-heading">
                        <h4>{t("Raindrops Breakdown")}</h4>
                    </div>
                    <div className="tabsmain">
                        <Tabs
                            onSelect={handleSelect}
                            id="controlled-tab-example"
                            activeKey={activeKey}
                            className="bannertabs"
                        >
                            <Tab eventKey="Investment Polls" title={t("My Predictions")}>
                                <div className="inner-tab-content">
                                    {loadertable ? (
                                        <div className="pb-5 pt-5">
                                            <LoaderTable />
                                        </div>
                                    ) : investments?.pools && investments?.pools?.length > 0 ? (
                                        investments?.pools?.map((investmentData, index) => {
                                            const indexcount = (currentPage - 1) * 10 + index + 1;
                                            const pool = investmentData.pool;
                                            const currentTime = new Date();
                                            const endDate = new Date(pool?.endDate);
                                            const matchingPnl = perpoolPnl?.find(
                                                (pnlData) => pnlData.pool === pool?._id
                                            );
                                            const status =
                                                currentTime > endDate
                                                    ? pool?.winnerOption &&
                                                        Object.keys(pool?.winnerOption).length > 0
                                                        ? "Winner Decided"
                                                        : "Being Reviewed"
                                                    : "Live";

                                            return (
                                                <Link to={detailPath(pool._id)}>
                                                    <div className="inner-row" key={index}>
                                                        <div className="rowleft">
                                                            <div className="rowleftinner serial">
                                                                <p className="rowpara">{t("No")}.</p>
                                                                <h5 className="rowmainhead">{indexcount}</h5>
                                                            </div>
                                                            <div className="rowleftinner">
                                                                <p className="rowpara">{t("Question")}</p>
                                                                <h5 className="rowmainhead">
                                                                    {pool?.question}
                                                                </h5>
                                                            </div>
                                                        </div>
                                                        <div className="rowright">
                                                            <div className="rowrightmain">
                                                                <div className="rowrightinner">
                                                                    <p className="rowpara">{t("Address")}</p>
                                                                    <h6 className="rowrighthead">
                                                                        {pool?.contractAddress?.slice(0, 5)}...
                                                                        {pool?.contractAddress?.slice(-3)}
                                                                        <svg
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                handleCopyClick(
                                                                                    "address",
                                                                                    pool?.contractAddress,
                                                                                    index
                                                                                );
                                                                            }}
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="14"
                                                                            height="14"
                                                                            viewBox="0 0 14 14"
                                                                            fill={
                                                                                copiedStates.address &&
                                                                                    copiedStates.index === index
                                                                                    ? "#DAD9D9"
                                                                                    : "none"
                                                                            }
                                                                        >
                                                                            <path
                                                                                d="M9.33366 7.525V9.97501C9.33366 12.0167 8.51699 12.8333 6.47533 12.8333H4.02533C1.98366 12.8333 1.16699 12.0167 1.16699 9.97501V7.525C1.16699 5.48334 1.98366 4.66667 4.02533 4.66667H6.47533C8.51699 4.66667 9.33366 5.48334 9.33366 7.525Z"
                                                                                stroke="#727272"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                            <path
                                                                                d="M12.8337 4.02501V6.47501C12.8337 8.51667 12.017 9.33334 9.97533 9.33334H9.33366V7.525C9.33366 5.48334 8.51699 4.66667 6.47533 4.66667H4.66699V4.02501C4.66699 1.98334 5.48366 1.16667 7.52533 1.16667H9.97533C12.017 1.16667 12.8337 1.98334 12.8337 4.02501Z"
                                                                                stroke="#727272"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                        </svg>
                                                                    </h6>
                                                                </div>

                                                                <div className="rowrightinner">
                                                                    <p className="rowpara">{t("MARKET ID")}</p>
                                                                    <h6 className="rowrighthead">
                                                                        {pool?._id?.slice(0, 5)}...
                                                                        {pool?._id?.slice(-3)}
                                                                        <svg
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                handleCopyClick("id", pool?._id, index);
                                                                            }}
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="14"
                                                                            height="14"
                                                                            viewBox="0 0 14 14"
                                                                            fill={
                                                                                copiedStates.id &&
                                                                                    copiedStates.index === index
                                                                                    ? "#DAD9D9"
                                                                                    : "none"
                                                                            }
                                                                        >
                                                                            <path
                                                                                d="M9.33366 7.525V9.97501C9.33366 12.0167 8.51699 12.8333 6.47533 12.8333H4.02533C1.98366 12.8333 1.16699 12.0167 1.16699 9.97501V7.525C1.16699 5.48334 1.98366 4.66667 4.02533 4.66667H6.47533C8.51699 4.66667 9.33366 5.48334 9.33366 7.525Z"
                                                                                stroke="#727272"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                            <path
                                                                                d="M12.8337 4.02501V6.47501C12.8337 8.51667 12.017 9.33334 9.97533 9.33334H9.33366V7.525C9.33366 5.48334 8.51699 4.66667 6.47533 4.66667H4.66699V4.02501C4.66699 1.98334 5.48366 1.16667 7.52533 1.16667H9.97533C12.017 1.16667 12.8337 1.98334 12.8337 4.02501Z"
                                                                                stroke="#727272"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                        </svg>
                                                                    </h6>
                                                                </div>
                                                                <div className="rowrightinner">
                                                                    <p className="rowpara">{t("PnL")}</p>
                                                                    <h6
                                                                        className="rowrighthead"
                                                                        style={{
                                                                            color:
                                                                                matchingPnl?.pnl > 0
                                                                                    ? "var(--green-text)"
                                                                                    : "var(--logout-text)",
                                                                        }}
                                                                    >
                                                                        {matchingPnl
                                                                            ? !isNaN(matchingPnl.pnl) &&
                                                                                matchingPnl.pnl !== "N/A"
                                                                                ? parseFloat(
                                                                                    convertFromWei(
                                                                                        matchingPnl.pnl.toString(),
                                                                                        "ether"
                                                                                    )
                                                                                )
                                                                                    .toFixed(3)
                                                                                    .replace(
                                                                                        /\B(?=(\d{3})+(?!\d))/g,
                                                                                        ","
                                                                                    )
                                                                                : "N/A"
                                                                            : "N/A"}
                                                                    </h6>
                                                                </div>
                                                                <div className="rowrightinner">
                                                                    <p className="rowpara">{t("Status")}</p>
                                                                    <h6
                                                                        className={
                                                                            status === "Live"
                                                                                ? "live"
                                                                                : status === "Winner Decided"
                                                                                    ? "winner"
                                                                                    : "reviewed"
                                                                        }
                                                                    >
                                                                        {status}
                                                                    </h6>
                                                                </div>
                                                            </div>
                                                            <div className="rowrightmain mbldirection">
                                                                {status === "Live" ? (
                                                                    <div className="rowrightinner">
                                                                        <Link to={detailPath(pool._id)}>
                                                                            <button className="dullbtn">
                                                                                {t("Get Detail")}
                                                                            </button>
                                                                        </Link>
                                                                    </div>
                                                                ) : !pool.poolFinalized ? (
                                                                    <div className="rowrightinner">
                                                                        <button
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                ClosePoolHandle(
                                                                                    pool?.contractAddress,
                                                                                    pool?.poolFinalized
                                                                                );
                                                                            }}
                                                                            className="decidebtn"
                                                                        >
                                                                            {t("Close Market")}
                                                                        </button>
                                                                    </div>
                                                                ) : (!pool?.winnerOption ||
                                                                    Object.keys(pool?.winnerOption).length ===
                                                                    0) &&
                                                                    pool.poolFinalized &&
                                                                    smartAccount?.toLowerCase() ===
                                                                    pool?.poolOwnerWalletAddress ? (
                                                                    <div className="rowrightinner">
                                                                        {pool?.isPrivate ? (
                                                                            <button
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    e.stopPropagation();
                                                                                    getPoolsById(
                                                                                        pool?._id,
                                                                                        pool?.poolOwnerWalletAddress
                                                                                    );
                                                                                }}
                                                                                className="decidebtn"
                                                                            >
                                                                                {t("Decide Winner")}
                                                                            </button>
                                                                        ) : (
                                                                            <button
                                                                                className="dullbtn"
                                                                            >
                                                                                {t("Get Detail")}
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                ) : pool?.winnerOption &&
                                                                    Object.keys(pool?.winnerOption).length > 0 &&
                                                                    pool.poolFinalized ? (
                                                                    <div className="rowrightinner">
                                                                        <Link to={detailPath(pool._id)}>
                                                                            <button className="dullbtn">
                                                                                {t("Get Detail")}
                                                                            </button>
                                                                        </Link>
                                                                    </div>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Link>
                                            );
                                        })
                                    ) : (
                                        <div className="whennopolls">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="113"
                                                height="112"
                                                viewBox="0 0 113 112"
                                                fill="none"
                                            >
                                                <path
                                                    d="M110.633 39.2002V42.9335L56.4996 61.6002L2.36625 42.9335V39.2002C2.36383 38.801 2.48942 38.4116 2.7246 38.0891C2.95977 37.7666 3.29214 37.5279 3.67291 37.4082L54.6329 21.0375L55.9209 20.6269C56.2956 20.4961 56.7035 20.4961 57.0782 20.6269L58.3662 21.0375L109.326 37.4082C109.707 37.5279 110.039 37.7666 110.275 38.0891C110.51 38.4116 110.635 38.801 110.633 39.2002Z"
                                                    fill="#2F2F2F"
                                                />
                                                <path
                                                    d="M110.633 39.2002V89.0215C110.632 89.7987 110.389 90.5564 109.938 91.1888C109.486 91.8213 108.848 92.2969 108.113 92.5495L58.3662 109.704L57.7129 109.928C56.9283 110.208 56.0709 110.208 55.2862 109.928L54.6329 109.704L4.88625 92.5495C4.15123 92.2969 3.51338 91.8213 3.06164 91.1888C2.6099 90.5564 2.3668 89.7987 2.36625 89.0215V39.2002C2.36383 39.5993 2.48942 39.9888 2.7246 40.3113C2.95977 40.6338 3.29214 40.8725 3.67291 40.9922L54.7076 57.3815L55.9209 57.7735C56.2956 57.9043 56.7035 57.9043 57.0782 57.7735L58.2916 57.3815L109.326 40.9922C109.707 40.8725 110.039 40.6338 110.275 40.3113C110.51 39.9888 110.635 39.5993 110.633 39.2002Z"
                                                    fill="#353535"
                                                />
                                                <path
                                                    d="M49.033 64.7736V97.2536C49.0323 97.5517 48.9606 97.8454 48.8239 98.1103C48.6871 98.3753 48.4893 98.6039 48.2467 98.7772C48.004 98.9505 47.7237 99.0635 47.4287 99.1069C47.1337 99.1503 46.8326 99.1229 46.5504 99.0269L11.0837 86.8002C10.7164 86.6718 10.3985 86.4319 10.1742 86.114C9.94999 85.796 9.8307 85.4159 9.83304 85.0269V53.3682C9.83326 53.0736 9.90321 52.7832 10.0372 52.5208C10.1712 52.2584 10.3653 52.0314 10.6038 51.8585C10.8424 51.6855 11.1184 51.5714 11.4095 51.5256C11.7005 51.4798 11.9983 51.5036 12.2784 51.5949L47.745 62.9816C48.1205 63.1076 48.4468 63.3484 48.6779 63.6699C48.909 63.9915 49.0333 64.3776 49.033 64.7736ZM103.166 53.3682V85.0269C103.169 85.4159 103.049 85.796 102.825 86.114C102.601 86.4319 102.283 86.6718 101.916 86.8002L66.449 99.0269C66.1668 99.1229 65.8657 99.1503 65.5707 99.1069C65.2758 99.0635 64.9954 98.9505 64.7527 98.7772C64.5101 98.6039 64.3123 98.3753 64.1755 98.1103C64.0388 97.8454 63.9671 97.5517 63.9664 97.2536V64.7736C63.9661 64.3776 64.0904 63.9915 64.3215 63.6699C64.5526 63.3484 64.8789 63.1076 65.2544 62.9816L100.721 51.5949C101.001 51.5036 101.299 51.4798 101.59 51.5256C101.881 51.5714 102.157 51.6855 102.396 51.8585C102.634 52.0314 102.828 52.2584 102.962 52.5208C103.096 52.7832 103.166 53.0736 103.166 53.3682Z"
                                                    fill="#2F2F2F"
                                                />
                                                <path
                                                    d="M58.3671 21.0375V48.5335C58.3671 49.0286 58.1705 49.5034 57.8204 49.8535C57.4703 50.2035 56.9955 50.4002 56.5005 50.4002C56.0054 50.4002 55.5306 50.2035 55.1805 49.8535C54.8305 49.5034 54.6338 49.0286 54.6338 48.5335V21.0375L55.9218 20.6269C56.2965 20.4961 56.7044 20.4961 57.0791 20.6269L58.3671 21.0375Z"
                                                    fill="#3E3E3E"
                                                />
                                                <path
                                                    d="M58.3666 57.8667V109.704L57.7132 109.928C56.9286 110.208 56.0712 110.208 55.2866 109.928L54.6332 109.704V57.8667C54.6292 57.7018 54.6545 57.5374 54.7079 57.3813L55.9212 57.7733C56.2959 57.9041 56.7039 57.9041 57.0786 57.7733L58.2919 57.3813C58.3453 57.5374 58.3706 57.7018 58.3666 57.8667Z"
                                                    fill="#2F2F2F"
                                                />
                                                <path
                                                    d="M49.033 74.0881V77.9334C48.8368 77.9283 48.6422 77.8969 48.4543 77.8401L9.83301 65.4268V61.6001C10.0293 61.6038 10.2242 61.6352 10.4117 61.6934L49.033 74.0881ZM49.033 86.7441V90.5708C48.8376 90.5724 48.6429 90.5473 48.4543 90.4961L9.83301 78.0828V74.2561C10.0293 74.2598 10.2242 74.2912 10.4117 74.3494L49.033 86.7441ZM103.166 65.8561V69.6828L93.049 72.9308C92.7104 73.0606 92.4225 73.2958 92.2276 73.6016C92.0327 73.9074 91.9411 74.2677 91.9663 74.6294C91.9743 76.2444 91.4585 77.8183 90.4962 79.1153C89.5339 80.4122 88.1771 81.3623 86.6292 81.8228C85.0814 82.2834 83.4259 82.2297 81.9111 81.6698C80.3963 81.1099 79.1039 80.074 78.2277 78.7174C78.0255 78.4596 77.746 78.2733 77.4302 78.186C77.1144 78.0986 76.7789 78.1148 76.473 78.2321L64.5263 82.0401C64.3475 82.1072 64.1573 82.1389 63.9663 82.1334V78.3068L75.3343 74.6668C76.4212 74.2932 77.6008 74.2882 78.6908 74.6527C79.7807 75.0171 80.7201 75.7306 81.3637 76.6828C81.6988 77.2106 82.1622 77.6449 82.7106 77.9452C83.2589 78.2455 83.8745 78.402 84.4997 78.4001C85.4889 78.3971 86.4368 78.0029 87.1363 77.3034C87.8358 76.6039 88.23 75.656 88.233 74.6668C88.2 73.5064 88.5392 72.3659 89.2008 71.412C89.8625 70.4582 90.8119 69.741 91.9103 69.3654L102.588 65.9494C102.775 65.8912 102.97 65.8598 103.166 65.8561Z"
                                                    fill="#3E3E3E"
                                                />
                                                <path
                                                    d="M56.5003 14.9333C56.0052 14.9333 55.5304 14.7367 55.1803 14.3866C54.8303 14.0365 54.6336 13.5617 54.6336 13.0667V1.86667C54.6336 1.3716 54.8303 0.896802 55.1803 0.546734C55.5304 0.196666 56.0052 0 56.5003 0C56.9953 0 57.4701 0.196666 57.8202 0.546734C58.1703 0.896802 58.3669 1.3716 58.3669 1.86667V13.0667C58.3669 13.5617 58.1703 14.0365 57.8202 14.3866C57.4701 14.7367 56.9953 14.9333 56.5003 14.9333ZM32.2336 18.6667C31.8851 18.6686 31.5431 18.5729 31.2462 18.3905C30.9493 18.208 30.7094 17.9461 30.5536 17.6344L24.9536 6.4344C24.7323 5.99131 24.6961 5.47846 24.8529 5.00867C25.0098 4.53888 25.3468 4.15063 25.7899 3.92933C26.233 3.70804 26.7458 3.67182 27.2156 3.82865C27.6854 3.98548 28.0737 4.32251 28.2949 4.7656L33.8949 15.9656C34.0368 16.2496 34.104 16.565 34.09 16.8821C34.0761 17.1993 33.9815 17.5076 33.8151 17.778C33.6488 18.0483 33.4163 18.2719 33.1396 18.4274C32.8629 18.5829 32.551 18.6652 32.2336 18.6667ZM80.7669 18.6667C80.4489 18.6665 80.1361 18.5851 79.8584 18.4301C79.5806 18.2751 79.3471 18.0517 79.1799 17.7811C79.0127 17.5105 78.9175 17.2017 78.9032 16.884C78.8889 16.5662 78.956 16.2501 79.0981 15.9656L84.6981 4.7656C84.9194 4.32251 85.3077 3.98548 85.7775 3.82865C86.2473 3.67182 86.7601 3.70804 87.2032 3.92933C87.6463 4.15063 87.9833 4.53888 88.1402 5.00867C88.297 5.47846 88.2608 5.99131 88.0395 6.4344L82.4395 17.6344C82.2843 17.945 82.0455 18.2061 81.7501 18.3885C81.4546 18.5708 81.1142 18.6672 80.7669 18.6667Z"
                                                    fill="#393939"
                                                />
                                            </svg>
                                            <p>{t("No Markets Found")}</p>
                                        </div>
                                    )}
                                    <div className="paginationmain">
                                        {!loadertable && investments?.pools?.length > 0 && (
                                            <Pagination>
                                                <Pagination.Prev
                                                    onClick={handlePrev}
                                                    disabled={currentPage === 1}
                                                >
                                                    <svg
                                                        width="12"
                                                        height="10"
                                                        viewBox="0 0 12 10"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="arrow"
                                                    >
                                                        <path
                                                            d="M0.137597 5.0194L4.35635 9.23815C4.4443 9.32611 4.5636 9.37552 4.68799 9.37552C4.81238 9.37552 4.93167 9.32611 5.01963 9.23815C5.10759 9.1502 5.157 9.0309 5.157 8.90651C5.157 8.78212 5.10759 8.66283 5.01963 8.57487L1.60068 5.15651L10.7817 5.15651C10.9061 5.15651 11.0253 5.10713 11.1132 5.01922C11.2011 4.93131 11.2505 4.81208 11.2505 4.68776C11.2505 4.56344 11.2011 4.44421 11.1132 4.3563C11.0253 4.2684 10.9061 4.21901 10.7817 4.21901L1.60068 4.21901L5.01963 0.800651C5.10759 0.712694 5.157 0.593399 5.157 0.46901C5.157 0.344621 5.10759 0.225326 5.01963 0.137369C4.93167 0.0494129 4.81238 -5.62838e-07 4.68799 -5.73712e-07C4.5636 -5.84586e-07 4.4443 0.0494129 4.35635 0.137369L0.137597 4.35612C0.0940147 4.39965 0.0594393 4.45135 0.0358501 4.50826C0.012261 4.56516 0.000119759 4.62616 0.000119753 4.68776C0.000119748 4.74936 0.012261 4.81036 0.0358501 4.86726C0.0594392 4.92417 0.0940147 4.97587 0.137597 5.0194Z"
                                                            fill="#494949"
                                                        />
                                                    </svg>
                                                </Pagination.Prev>

                                                {[...Array(totalPages)].map((_, index) => {
                                                    const page = index + 1;
                                                    return (
                                                        <Pagination.Item
                                                            key={page}
                                                            active={currentPage === page}
                                                            onClick={() => handlePageChange(page)}
                                                        >
                                                            {page}
                                                        </Pagination.Item>
                                                    );
                                                })}
                                                <Pagination.Next
                                                    onClick={handleNext}
                                                    disabled={currentPage === totalPages}
                                                >
                                                    <svg
                                                        width="12"
                                                        height="10"
                                                        viewBox="0 0 12 10"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="arrow"
                                                    >
                                                        <path
                                                            d="M11.1129 4.35612L6.89414 0.137367C6.80618 0.0494103 6.68689 -3.37512e-06 6.5625 -3.37512e-06C6.43811 -3.37512e-06 6.31882 0.0494103 6.23086 0.137367C6.1429 0.225323 6.09349 0.344618 6.09349 0.469008C6.09349 0.593397 6.1429 0.712692 6.23086 0.800649L9.6498 4.21901H0.46875C0.34443 4.21901 0.225201 4.26839 0.137294 4.3563C0.0493861 4.44421 0 4.56344 0 4.68776C0 4.81208 0.0493861 4.93131 0.137294 5.01921C0.225201 5.10712 0.34443 5.15651 0.46875 5.15651H9.6498L6.23086 8.57487C6.1429 8.66282 6.09349 8.78212 6.09349 8.90651C6.09349 9.0309 6.1429 9.15019 6.23086 9.23815C6.31882 9.32611 6.43811 9.37552 6.5625 9.37552C6.68689 9.37552 6.80618 9.32611 6.89414 9.23815L11.1129 5.0194C11.1565 4.97586 11.191 4.92417 11.2146 4.86726C11.2382 4.81036 11.2504 4.74936 11.2504 4.68776C11.2504 4.62616 11.2382 4.56516 11.2146 4.50825C11.191 4.45135 11.1565 4.39965 11.1129 4.35612Z"
                                                            fill="#494949"
                                                        />
                                                    </svg>
                                                </Pagination.Next>
                                            </Pagination>
                                        )}
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="Public Polls" title={t("Public Markets")}>
                                <div className="inner-tab-content">
                                    {loadertable ? (
                                        <div className="pb-5 pt-5">
                                            <LoaderTable />
                                        </div>
                                    ) : publicpools && publicpools?.length > 0 ? (
                                        publicpools.map((pool, index) => {
                                            const indexcount = (currentPage - 1) * 10 + index + 1;
                                            const currentTime = new Date();
                                            const endDate = new Date(pool?.endDate);
                                            const status =
                                                currentTime > endDate
                                                    ? pool?.winnerOption &&
                                                        Object.keys(pool?.winnerOption).length > 0
                                                        ? "Winner Decided"
                                                        : "Being Reviewed"
                                                    : "Live";
                                            return (
                                                <Link to={detailPath(pool._id)}>
                                                    <div className="inner-row" key={pool._id}>
                                                        <div className="rowleft">
                                                            <div className="rowleftinner serial">
                                                                <p className="rowpara">{t("No")}.</p>
                                                                <h5 className="rowmainhead">{indexcount}</h5>
                                                            </div>
                                                            <div className="rowleftinner">
                                                                <p className="rowpara">{t("Question")}</p>
                                                                <h5 className="rowmainhead">
                                                                    {pool?.question}
                                                                </h5>
                                                            </div>
                                                        </div>
                                                        <div className="rowright">
                                                            <div className="rowrightmain">
                                                                <div className="rowrightinner">
                                                                    <p className="rowpara">{t("Address")}</p>
                                                                    <h6 className="rowrighthead">
                                                                        {pool?.contractAddress?.slice(0, 5)}...
                                                                        {pool?.contractAddress?.slice(-3)}
                                                                        <svg
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                handleCopyClick(
                                                                                    "address",
                                                                                    pool?.contractAddress,
                                                                                    index
                                                                                );
                                                                            }}
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="14"
                                                                            height="14"
                                                                            viewBox="0 0 14 14"
                                                                            fill={
                                                                                copiedStates.address &&
                                                                                    copiedStates.index === index
                                                                                    ? "#DAD9D9"
                                                                                    : "none"
                                                                            }
                                                                        >
                                                                            <path
                                                                                d="M9.33366 7.525V9.97501C9.33366 12.0167 8.51699 12.8333 6.47533 12.8333H4.02533C1.98366 12.8333 1.16699 12.0167 1.16699 9.97501V7.525C1.16699 5.48334 1.98366 4.66667 4.02533 4.66667H6.47533C8.51699 4.66667 9.33366 5.48334 9.33366 7.525Z"
                                                                                stroke="#727272"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                            <path
                                                                                d="M12.8337 4.02501V6.47501C12.8337 8.51667 12.017 9.33334 9.97533 9.33334H9.33366V7.525C9.33366 5.48334 8.51699 4.66667 6.47533 4.66667H4.66699V4.02501C4.66699 1.98334 5.48366 1.16667 7.52533 1.16667H9.97533C12.017 1.16667 12.8337 1.98334 12.8337 4.02501Z"
                                                                                stroke="#727272"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                        </svg>
                                                                    </h6>
                                                                </div>
                                                                <div className="rowrightinner">
                                                                    <p className="rowpara">{t("MARKET ID")}</p>
                                                                    <h6 className="rowrighthead">
                                                                        {pool?._id?.slice(0, 5)}...
                                                                        {pool?._id?.slice(-3)}
                                                                        <svg
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                handleCopyClick("id", pool?._id, index);
                                                                            }}
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="14"
                                                                            height="14"
                                                                            viewBox="0 0 14 14"
                                                                            fill={
                                                                                copiedStates.id &&
                                                                                    copiedStates.index === index
                                                                                    ? "#DAD9D9"
                                                                                    : "none"
                                                                            }
                                                                        >
                                                                            <path
                                                                                d="M9.33366 7.525V9.97501C9.33366 12.0167 8.51699 12.8333 6.47533 12.8333H4.02533C1.98366 12.8333 1.16699 12.0167 1.16699 9.97501V7.525C1.16699 5.48334 1.98366 4.66667 4.02533 4.66667H6.47533C8.51699 4.66667 9.33366 5.48334 9.33366 7.525Z"
                                                                                stroke="#727272"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                            <path
                                                                                d="M12.8337 4.02501V6.47501C12.8337 8.51667 12.017 9.33334 9.97533 9.33334H9.33366V7.525C9.33366 5.48334 8.51699 4.66667 6.47533 4.66667H4.66699V4.02501C4.66699 1.98334 5.48366 1.16667 7.52533 1.16667H9.97533C12.017 1.16667 12.8337 1.98334 12.8337 4.02501Z"
                                                                                stroke="#727272"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                        </svg>
                                                                    </h6>
                                                                </div>
                                                                <div className="rowrightinner">
                                                                    <p className="rowpara">{t("Status")}</p>
                                                                    <h6
                                                                        className={
                                                                            status === "Live"
                                                                                ? "live"
                                                                                : status === "Winner Decided"
                                                                                    ? "winner"
                                                                                    : "reviewed"
                                                                        }
                                                                    >
                                                                        {status}
                                                                    </h6>
                                                                </div>
                                                            </div>
                                                            <div className="rowrightmain mbldirection">
                                                                {status === "Live" ? (
                                                                    <div className="rowrightinner">
                                                                        <Link to={detailPath(pool._id)}>
                                                                            <button className="dullbtn">
                                                                                {t("Get Detail")}
                                                                            </button>
                                                                        </Link>
                                                                    </div>
                                                                ) : !pool.poolFinalized ? (
                                                                    <div className="rowrightinner">
                                                                        <button
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                ClosePoolHandle(
                                                                                    pool?.contractAddress,
                                                                                    pool?.poolFinalized
                                                                                );
                                                                            }}
                                                                            className="decidebtn"
                                                                        >
                                                                            {t("Close Market")}
                                                                        </button>
                                                                    </div>
                                                                ) : pool.poolFinalized ? (
                                                                    <div className="rowrightinner">
                                                                        <button className="dullbtn">
                                                                            {t("Get Detail")}
                                                                        </button>
                                                                    </div>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Link>
                                            );
                                        })
                                    ) : (
                                        <div className="whennopolls">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="113"
                                                height="112"
                                                viewBox="0 0 113 112"
                                                fill="none"
                                            >
                                                <path
                                                    d="M110.633 39.2002V42.9335L56.4996 61.6002L2.36625 42.9335V39.2002C2.36383 38.801 2.48942 38.4116 2.7246 38.0891C2.95977 37.7666 3.29214 37.5279 3.67291 37.4082L54.6329 21.0375L55.9209 20.6269C56.2956 20.4961 56.7035 20.4961 57.0782 20.6269L58.3662 21.0375L109.326 37.4082C109.707 37.5279 110.039 37.7666 110.275 38.0891C110.51 38.4116 110.635 38.801 110.633 39.2002Z"
                                                    fill="#2F2F2F"
                                                />
                                                <path
                                                    d="M110.633 39.2002V89.0215C110.632 89.7987 110.389 90.5564 109.938 91.1888C109.486 91.8213 108.848 92.2969 108.113 92.5495L58.3662 109.704L57.7129 109.928C56.9283 110.208 56.0709 110.208 55.2862 109.928L54.6329 109.704L4.88625 92.5495C4.15123 92.2969 3.51338 91.8213 3.06164 91.1888C2.6099 90.5564 2.3668 89.7987 2.36625 89.0215V39.2002C2.36383 39.5993 2.48942 39.9888 2.7246 40.3113C2.95977 40.6338 3.29214 40.8725 3.67291 40.9922L54.7076 57.3815L55.9209 57.7735C56.2956 57.9043 56.7035 57.9043 57.0782 57.7735L58.2916 57.3815L109.326 40.9922C109.707 40.8725 110.039 40.6338 110.275 40.3113C110.51 39.9888 110.635 39.5993 110.633 39.2002Z"
                                                    fill="#353535"
                                                />
                                                <path
                                                    d="M49.033 64.7736V97.2536C49.0323 97.5517 48.9606 97.8454 48.8239 98.1103C48.6871 98.3753 48.4893 98.6039 48.2467 98.7772C48.004 98.9505 47.7237 99.0635 47.4287 99.1069C47.1337 99.1503 46.8326 99.1229 46.5504 99.0269L11.0837 86.8002C10.7164 86.6718 10.3985 86.4319 10.1742 86.114C9.94999 85.796 9.8307 85.4159 9.83304 85.0269V53.3682C9.83326 53.0736 9.90321 52.7832 10.0372 52.5208C10.1712 52.2584 10.3653 52.0314 10.6038 51.8585C10.8424 51.6855 11.1184 51.5714 11.4095 51.5256C11.7005 51.4798 11.9983 51.5036 12.2784 51.5949L47.745 62.9816C48.1205 63.1076 48.4468 63.3484 48.6779 63.6699C48.909 63.9915 49.0333 64.3776 49.033 64.7736ZM103.166 53.3682V85.0269C103.169 85.4159 103.049 85.796 102.825 86.114C102.601 86.4319 102.283 86.6718 101.916 86.8002L66.449 99.0269C66.1668 99.1229 65.8657 99.1503 65.5707 99.1069C65.2758 99.0635 64.9954 98.9505 64.7527 98.7772C64.5101 98.6039 64.3123 98.3753 64.1755 98.1103C64.0388 97.8454 63.9671 97.5517 63.9664 97.2536V64.7736C63.9661 64.3776 64.0904 63.9915 64.3215 63.6699C64.5526 63.3484 64.8789 63.1076 65.2544 62.9816L100.721 51.5949C101.001 51.5036 101.299 51.4798 101.59 51.5256C101.881 51.5714 102.157 51.6855 102.396 51.8585C102.634 52.0314 102.828 52.2584 102.962 52.5208C103.096 52.7832 103.166 53.0736 103.166 53.3682Z"
                                                    fill="#2F2F2F"
                                                />
                                                <path
                                                    d="M58.3671 21.0375V48.5335C58.3671 49.0286 58.1705 49.5034 57.8204 49.8535C57.4703 50.2035 56.9955 50.4002 56.5005 50.4002C56.0054 50.4002 55.5306 50.2035 55.1805 49.8535C54.8305 49.5034 54.6338 49.0286 54.6338 48.5335V21.0375L55.9218 20.6269C56.2965 20.4961 56.7044 20.4961 57.0791 20.6269L58.3671 21.0375Z"
                                                    fill="#3E3E3E"
                                                />
                                                <path
                                                    d="M58.3666 57.8667V109.704L57.7132 109.928C56.9286 110.208 56.0712 110.208 55.2866 109.928L54.6332 109.704V57.8667C54.6292 57.7018 54.6545 57.5374 54.7079 57.3813L55.9212 57.7733C56.2959 57.9041 56.7039 57.9041 57.0786 57.7733L58.2919 57.3813C58.3453 57.5374 58.3706 57.7018 58.3666 57.8667Z"
                                                    fill="#2F2F2F"
                                                />
                                                <path
                                                    d="M49.033 74.0881V77.9334C48.8368 77.9283 48.6422 77.8969 48.4543 77.8401L9.83301 65.4268V61.6001C10.0293 61.6038 10.2242 61.6352 10.4117 61.6934L49.033 74.0881ZM49.033 86.7441V90.5708C48.8376 90.5724 48.6429 90.5473 48.4543 90.4961L9.83301 78.0828V74.2561C10.0293 74.2598 10.2242 74.2912 10.4117 74.3494L49.033 86.7441ZM103.166 65.8561V69.6828L93.049 72.9308C92.7104 73.0606 92.4225 73.2958 92.2276 73.6016C92.0327 73.9074 91.9411 74.2677 91.9663 74.6294C91.9743 76.2444 91.4585 77.8183 90.4962 79.1153C89.5339 80.4122 88.1771 81.3623 86.6292 81.8228C85.0814 82.2834 83.4259 82.2297 81.9111 81.6698C80.3963 81.1099 79.1039 80.074 78.2277 78.7174C78.0255 78.4596 77.746 78.2733 77.4302 78.186C77.1144 78.0986 76.7789 78.1148 76.473 78.2321L64.5263 82.0401C64.3475 82.1072 64.1573 82.1389 63.9663 82.1334V78.3068L75.3343 74.6668C76.4212 74.2932 77.6008 74.2882 78.6908 74.6527C79.7807 75.0171 80.7201 75.7306 81.3637 76.6828C81.6988 77.2106 82.1622 77.6449 82.7106 77.9452C83.2589 78.2455 83.8745 78.402 84.4997 78.4001C85.4889 78.3971 86.4368 78.0029 87.1363 77.3034C87.8358 76.6039 88.23 75.656 88.233 74.6668C88.2 73.5064 88.5392 72.3659 89.2008 71.412C89.8625 70.4582 90.8119 69.741 91.9103 69.3654L102.588 65.9494C102.775 65.8912 102.97 65.8598 103.166 65.8561Z"
                                                    fill="#3E3E3E"
                                                />
                                                <path
                                                    d="M56.5003 14.9333C56.0052 14.9333 55.5304 14.7367 55.1803 14.3866C54.8303 14.0365 54.6336 13.5617 54.6336 13.0667V1.86667C54.6336 1.3716 54.8303 0.896802 55.1803 0.546734C55.5304 0.196666 56.0052 0 56.5003 0C56.9953 0 57.4701 0.196666 57.8202 0.546734C58.1703 0.896802 58.3669 1.3716 58.3669 1.86667V13.0667C58.3669 13.5617 58.1703 14.0365 57.8202 14.3866C57.4701 14.7367 56.9953 14.9333 56.5003 14.9333ZM32.2336 18.6667C31.8851 18.6686 31.5431 18.5729 31.2462 18.3905C30.9493 18.208 30.7094 17.9461 30.5536 17.6344L24.9536 6.4344C24.7323 5.99131 24.6961 5.47846 24.8529 5.00867C25.0098 4.53888 25.3468 4.15063 25.7899 3.92933C26.233 3.70804 26.7458 3.67182 27.2156 3.82865C27.6854 3.98548 28.0737 4.32251 28.2949 4.7656L33.8949 15.9656C34.0368 16.2496 34.104 16.565 34.09 16.8821C34.0761 17.1993 33.9815 17.5076 33.8151 17.778C33.6488 18.0483 33.4163 18.2719 33.1396 18.4274C32.8629 18.5829 32.551 18.6652 32.2336 18.6667ZM80.7669 18.6667C80.4489 18.6665 80.1361 18.5851 79.8584 18.4301C79.5806 18.2751 79.3471 18.0517 79.1799 17.7811C79.0127 17.5105 78.9175 17.2017 78.9032 16.884C78.8889 16.5662 78.956 16.2501 79.0981 15.9656L84.6981 4.7656C84.9194 4.32251 85.3077 3.98548 85.7775 3.82865C86.2473 3.67182 86.7601 3.70804 87.2032 3.92933C87.6463 4.15063 87.9833 4.53888 88.1402 5.00867C88.297 5.47846 88.2608 5.99131 88.0395 6.4344L82.4395 17.6344C82.2843 17.945 82.0455 18.2061 81.7501 18.3885C81.4546 18.5708 81.1142 18.6672 80.7669 18.6667Z"
                                                    fill="#393939"
                                                />
                                            </svg>
                                            <p>{t("No Markets Found")}</p>
                                        </div>
                                    )}

                                    <div className="paginationmain">
                                        {!loadertable && publicpools?.length > 0 && (
                                            <Pagination>
                                                <Pagination.Prev
                                                    onClick={handlePrev}
                                                    disabled={currentPage === 1}
                                                >
                                                    <svg
                                                        width="12"
                                                        height="10"
                                                        viewBox="0 0 12 10"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="arrow"
                                                    >
                                                        <path
                                                            d="M0.137597 5.0194L4.35635 9.23815C4.4443 9.32611 4.5636 9.37552 4.68799 9.37552C4.81238 9.37552 4.93167 9.32611 5.01963 9.23815C5.10759 9.1502 5.157 9.0309 5.157 8.90651C5.157 8.78212 5.10759 8.66283 5.01963 8.57487L1.60068 5.15651L10.7817 5.15651C10.9061 5.15651 11.0253 5.10713 11.1132 5.01922C11.2011 4.93131 11.2505 4.81208 11.2505 4.68776C11.2505 4.56344 11.2011 4.44421 11.1132 4.3563C11.0253 4.2684 10.9061 4.21901 10.7817 4.21901L1.60068 4.21901L5.01963 0.800651C5.10759 0.712694 5.157 0.593399 5.157 0.46901C5.157 0.344621 5.10759 0.225326 5.01963 0.137369C4.93167 0.0494129 4.81238 -5.62838e-07 4.68799 -5.73712e-07C4.5636 -5.84586e-07 4.4443 0.0494129 4.35635 0.137369L0.137597 4.35612C0.0940147 4.39965 0.0594393 4.45135 0.0358501 4.50826C0.012261 4.56516 0.000119759 4.62616 0.000119753 4.68776C0.000119748 4.74936 0.012261 4.81036 0.0358501 4.86726C0.0594392 4.92417 0.0940147 4.97587 0.137597 5.0194Z"
                                                            fill="#494949"
                                                        />
                                                    </svg>
                                                </Pagination.Prev>

                                                {[...Array(totalPages)].map((_, index) => {
                                                    const page = index + 1;
                                                    return (
                                                        <Pagination.Item
                                                            key={page}
                                                            active={currentPage === page}
                                                            onClick={() => handlePageChange(page)}
                                                        >
                                                            {page}
                                                        </Pagination.Item>
                                                    );
                                                })}
                                                <Pagination.Next
                                                    onClick={handleNext}
                                                    disabled={currentPage === totalPages}
                                                >
                                                    <svg
                                                        width="12"
                                                        height="10"
                                                        viewBox="0 0 12 10"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="arrow"
                                                    >
                                                        <path
                                                            d="M11.1129 4.35612L6.89414 0.137367C6.80618 0.0494103 6.68689 -3.37512e-06 6.5625 -3.37512e-06C6.43811 -3.37512e-06 6.31882 0.0494103 6.23086 0.137367C6.1429 0.225323 6.09349 0.344618 6.09349 0.469008C6.09349 0.593397 6.1429 0.712692 6.23086 0.800649L9.6498 4.21901H0.46875C0.34443 4.21901 0.225201 4.26839 0.137294 4.3563C0.0493861 4.44421 0 4.56344 0 4.68776C0 4.81208 0.0493861 4.93131 0.137294 5.01921C0.225201 5.10712 0.34443 5.15651 0.46875 5.15651H9.6498L6.23086 8.57487C6.1429 8.66282 6.09349 8.78212 6.09349 8.90651C6.09349 9.0309 6.1429 9.15019 6.23086 9.23815C6.31882 9.32611 6.43811 9.37552 6.5625 9.37552C6.68689 9.37552 6.80618 9.32611 6.89414 9.23815L11.1129 5.0194C11.1565 4.97586 11.191 4.92417 11.2146 4.86726C11.2382 4.81036 11.2504 4.74936 11.2504 4.68776C11.2504 4.62616 11.2382 4.56516 11.2146 4.50825C11.191 4.45135 11.1565 4.39965 11.1129 4.35612Z"
                                                            fill="#494949"
                                                        />
                                                    </svg>
                                                </Pagination.Next>
                                            </Pagination>
                                        )}
                                    </div>
                                </div>
                            </Tab>
                            <Tab
                                eventKey="Private Polls"
                                title={t("Private Markets")}
                            >
                                <div className="inner-tab-content">
                                    {loadertable ? (
                                        <div className="pb-5 pt-5">
                                            <LoaderTable />
                                        </div>
                                    ) : pools && pools?.length > 0 ? (
                                        pools.map((pool, index) => {
                                            const indexcount = (currentPage - 1) * 10 + index + 1;
                                            const currentTime = new Date();
                                            const endDate = new Date(pool?.endDate);
                                            const status =
                                                currentTime > endDate
                                                    ? pool?.winnerOption &&
                                                        Object.keys(pool?.winnerOption).length > 0
                                                        ? "Winner Decided"
                                                        : "Being Reviewed"
                                                    : "Live";
                                            return (
                                                <Link to={detailPath(pool._id)}>
                                                    <div className="inner-row" key={pool._id}>
                                                        <div className="rowleft">
                                                            <div className="rowleftinner serial">
                                                                <p className="rowpara">{t("No")}.</p>
                                                                <h5 className="rowmainhead">{indexcount}</h5>
                                                            </div>
                                                            <div className="rowleftinner">
                                                                <p className="rowpara">{t("Question")}</p>
                                                                <h5 className="rowmainhead">
                                                                    {pool?.question}
                                                                </h5>
                                                            </div>
                                                        </div>
                                                        <div className="rowright">
                                                            <div className="rowrightmain">
                                                                <div className="rowrightinner">
                                                                    <p className="rowpara">{t("Access Code")}</p>
                                                                    <h6 className="rowrighthead">
                                                                        {pool?.accessCode}
                                                                        <svg
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                handleCopyClick(
                                                                                    "accessCode",
                                                                                    pool?.accessCode,
                                                                                    index
                                                                                );
                                                                            }}
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="14"
                                                                            height="14"
                                                                            viewBox="0 0 14 14"
                                                                            fill={
                                                                                copiedStates.accessCode &&
                                                                                    copiedStates.index === index
                                                                                    ? "#DAD9D9"
                                                                                    : "none"
                                                                            }
                                                                        >
                                                                            <path
                                                                                d="M9.33366 7.525V9.97501C9.33366 12.0167 8.51699 12.8333 6.47533 12.8333H4.02533C1.98366 12.8333 1.16699 12.0167 1.16699 9.97501V7.525C1.16699 5.48334 1.98366 4.66667 4.02533 4.66667H6.47533C8.51699 4.66667 9.33366 5.48334 9.33366 7.525Z"
                                                                                stroke="#727272"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                            <path
                                                                                d="M12.8337 4.02501V6.47501C12.8337 8.51667 12.017 9.33334 9.97533 9.33334H9.33366V7.525C9.33366 5.48334 8.51699 4.66667 6.47533 4.66667H4.66699V4.02501C4.66699 1.98334 5.48366 1.16667 7.52533 1.16667H9.97533C12.017 1.16667 12.8337 1.98334 12.8337 4.02501Z"
                                                                                stroke="#727272"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                        </svg>
                                                                    </h6>
                                                                </div>
                                                                <div className="rowrightinner">
                                                                    <p className="rowpara">{t("Address")}</p>
                                                                    <h6 className="rowrighthead">
                                                                        {pool?.contractAddress?.slice(0, 5)}...
                                                                        {pool?.contractAddress?.slice(-3)}
                                                                        <svg
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                handleCopyClick(
                                                                                    "address",
                                                                                    pool?.contractAddress,
                                                                                    index
                                                                                );
                                                                            }}
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="14"
                                                                            height="14"
                                                                            viewBox="0 0 14 14"
                                                                            fill={
                                                                                copiedStates.address &&
                                                                                    copiedStates.index === index
                                                                                    ? "#DAD9D9"
                                                                                    : "none"
                                                                            }
                                                                        >
                                                                            <path
                                                                                d="M9.33366 7.525V9.97501C9.33366 12.0167 8.51699 12.8333 6.47533 12.8333H4.02533C1.98366 12.8333 1.16699 12.0167 1.16699 9.97501V7.525C1.16699 5.48334 1.98366 4.66667 4.02533 4.66667H6.47533C8.51699 4.66667 9.33366 5.48334 9.33366 7.525Z"
                                                                                stroke="#727272"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                            <path
                                                                                d="M12.8337 4.02501V6.47501C12.8337 8.51667 12.017 9.33334 9.97533 9.33334H9.33366V7.525C9.33366 5.48334 8.51699 4.66667 6.47533 4.66667H4.66699V4.02501C4.66699 1.98334 5.48366 1.16667 7.52533 1.16667H9.97533C12.017 1.16667 12.8337 1.98334 12.8337 4.02501Z"
                                                                                stroke="#727272"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                        </svg>
                                                                    </h6>
                                                                </div>
                                                                <div className="rowrightinner">
                                                                    <p className="rowpara">{t("MARKET ID")}</p>
                                                                    <h6 className="rowrighthead">
                                                                        {pool?._id?.slice(0, 5)}...
                                                                        {pool?._id?.slice(-3)}
                                                                        <svg
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                handleCopyClick("id", pool?._id, index);
                                                                            }}
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="14"
                                                                            height="14"
                                                                            viewBox="0 0 14 14"
                                                                            fill={
                                                                                copiedStates.id &&
                                                                                    copiedStates.index === index
                                                                                    ? "#DAD9D9"
                                                                                    : "none"
                                                                            }
                                                                        >
                                                                            <path
                                                                                d="M9.33366 7.525V9.97501C9.33366 12.0167 8.51699 12.8333 6.47533 12.8333H4.02533C1.98366 12.8333 1.16699 12.0167 1.16699 9.97501V7.525C1.16699 5.48334 1.98366 4.66667 4.02533 4.66667H6.47533C8.51699 4.66667 9.33366 5.48334 9.33366 7.525Z"
                                                                                stroke="#727272"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                            <path
                                                                                d="M12.8337 4.02501V6.47501C12.8337 8.51667 12.017 9.33334 9.97533 9.33334H9.33366V7.525C9.33366 5.48334 8.51699 4.66667 6.47533 4.66667H4.66699V4.02501C4.66699 1.98334 5.48366 1.16667 7.52533 1.16667H9.97533C12.017 1.16667 12.8337 1.98334 12.8337 4.02501Z"
                                                                                stroke="#727272"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                        </svg>
                                                                    </h6>
                                                                </div>
                                                            </div>
                                                            <div className="rowrightmain mbldirection">
                                                                <div className="rowrightinner">
                                                                    <p className="rowpara">{t("Status")}</p>
                                                                    <h6
                                                                        className={
                                                                            status === "Live"
                                                                                ? "live"
                                                                                : status === "Winner Decided"
                                                                                    ? "winner"
                                                                                    : "reviewed"
                                                                        }
                                                                    >
                                                                        {status}
                                                                    </h6>
                                                                </div>
                                                                {status === "Live" ? (
                                                                    <div className="rowrightinner">
                                                                        <Link to={detailPath(pool._id)}>
                                                                            <button className="dullbtn">
                                                                                {t("Get Detail")}
                                                                            </button>
                                                                        </Link>
                                                                    </div>
                                                                ) : !pool.poolFinalized ? (
                                                                    <div className="rowrightinner">
                                                                        <button
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                ClosePoolHandle(
                                                                                    pool?.contractAddress,
                                                                                    pool?.poolFinalized
                                                                                );
                                                                            }}
                                                                            className="decidebtn"
                                                                        >
                                                                            {t("Close Market")}
                                                                        </button>
                                                                    </div>
                                                                ) : (!pool?.winnerOption ||
                                                                    Object.keys(pool?.winnerOption).length ===
                                                                    0) &&
                                                                    pool.poolFinalized ? (
                                                                    <div className="rowrightinner">
                                                                        <button
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                getPoolsById(
                                                                                    pool?._id,
                                                                                    pool?.poolOwnerWalletAddress
                                                                                );
                                                                            }}
                                                                            className="decidebtn"
                                                                        >
                                                                            {t("Decide Winner")}
                                                                        </button>
                                                                    </div>
                                                                ) : pool?.winnerOption &&
                                                                    Object.keys(pool?.winnerOption).length > 0 &&
                                                                    pool.poolFinalized ? (
                                                                    <div className="rowrightinner">
                                                                        <Link to={detailPath(pool._id)}>
                                                                            <button className="dullbtn">
                                                                                {t("Get Detail")}
                                                                            </button>
                                                                        </Link>
                                                                    </div>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Link>
                                            );
                                        })
                                    ) : (
                                        <div className="whennopolls">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="113"
                                                height="112"
                                                viewBox="0 0 113 112"
                                                fill="none"
                                            >
                                                <path
                                                    d="M110.633 39.2002V42.9335L56.4996 61.6002L2.36625 42.9335V39.2002C2.36383 38.801 2.48942 38.4116 2.7246 38.0891C2.95977 37.7666 3.29214 37.5279 3.67291 37.4082L54.6329 21.0375L55.9209 20.6269C56.2956 20.4961 56.7035 20.4961 57.0782 20.6269L58.3662 21.0375L109.326 37.4082C109.707 37.5279 110.039 37.7666 110.275 38.0891C110.51 38.4116 110.635 38.801 110.633 39.2002Z"
                                                    fill="#2F2F2F"
                                                />
                                                <path
                                                    d="M110.633 39.2002V89.0215C110.632 89.7987 110.389 90.5564 109.938 91.1888C109.486 91.8213 108.848 92.2969 108.113 92.5495L58.3662 109.704L57.7129 109.928C56.9283 110.208 56.0709 110.208 55.2862 109.928L54.6329 109.704L4.88625 92.5495C4.15123 92.2969 3.51338 91.8213 3.06164 91.1888C2.6099 90.5564 2.3668 89.7987 2.36625 89.0215V39.2002C2.36383 39.5993 2.48942 39.9888 2.7246 40.3113C2.95977 40.6338 3.29214 40.8725 3.67291 40.9922L54.7076 57.3815L55.9209 57.7735C56.2956 57.9043 56.7035 57.9043 57.0782 57.7735L58.2916 57.3815L109.326 40.9922C109.707 40.8725 110.039 40.6338 110.275 40.3113C110.51 39.9888 110.635 39.5993 110.633 39.2002Z"
                                                    fill="#353535"
                                                />
                                                <path
                                                    d="M49.033 64.7736V97.2536C49.0323 97.5517 48.9606 97.8454 48.8239 98.1103C48.6871 98.3753 48.4893 98.6039 48.2467 98.7772C48.004 98.9505 47.7237 99.0635 47.4287 99.1069C47.1337 99.1503 46.8326 99.1229 46.5504 99.0269L11.0837 86.8002C10.7164 86.6718 10.3985 86.4319 10.1742 86.114C9.94999 85.796 9.8307 85.4159 9.83304 85.0269V53.3682C9.83326 53.0736 9.90321 52.7832 10.0372 52.5208C10.1712 52.2584 10.3653 52.0314 10.6038 51.8585C10.8424 51.6855 11.1184 51.5714 11.4095 51.5256C11.7005 51.4798 11.9983 51.5036 12.2784 51.5949L47.745 62.9816C48.1205 63.1076 48.4468 63.3484 48.6779 63.6699C48.909 63.9915 49.0333 64.3776 49.033 64.7736ZM103.166 53.3682V85.0269C103.169 85.4159 103.049 85.796 102.825 86.114C102.601 86.4319 102.283 86.6718 101.916 86.8002L66.449 99.0269C66.1668 99.1229 65.8657 99.1503 65.5707 99.1069C65.2758 99.0635 64.9954 98.9505 64.7527 98.7772C64.5101 98.6039 64.3123 98.3753 64.1755 98.1103C64.0388 97.8454 63.9671 97.5517 63.9664 97.2536V64.7736C63.9661 64.3776 64.0904 63.9915 64.3215 63.6699C64.5526 63.3484 64.8789 63.1076 65.2544 62.9816L100.721 51.5949C101.001 51.5036 101.299 51.4798 101.59 51.5256C101.881 51.5714 102.157 51.6855 102.396 51.8585C102.634 52.0314 102.828 52.2584 102.962 52.5208C103.096 52.7832 103.166 53.0736 103.166 53.3682Z"
                                                    fill="#2F2F2F"
                                                />
                                                <path
                                                    d="M58.3671 21.0375V48.5335C58.3671 49.0286 58.1705 49.5034 57.8204 49.8535C57.4703 50.2035 56.9955 50.4002 56.5005 50.4002C56.0054 50.4002 55.5306 50.2035 55.1805 49.8535C54.8305 49.5034 54.6338 49.0286 54.6338 48.5335V21.0375L55.9218 20.6269C56.2965 20.4961 56.7044 20.4961 57.0791 20.6269L58.3671 21.0375Z"
                                                    fill="#3E3E3E"
                                                />
                                                <path
                                                    d="M58.3666 57.8667V109.704L57.7132 109.928C56.9286 110.208 56.0712 110.208 55.2866 109.928L54.6332 109.704V57.8667C54.6292 57.7018 54.6545 57.5374 54.7079 57.3813L55.9212 57.7733C56.2959 57.9041 56.7039 57.9041 57.0786 57.7733L58.2919 57.3813C58.3453 57.5374 58.3706 57.7018 58.3666 57.8667Z"
                                                    fill="#2F2F2F"
                                                />
                                                <path
                                                    d="M49.033 74.0881V77.9334C48.8368 77.9283 48.6422 77.8969 48.4543 77.8401L9.83301 65.4268V61.6001C10.0293 61.6038 10.2242 61.6352 10.4117 61.6934L49.033 74.0881ZM49.033 86.7441V90.5708C48.8376 90.5724 48.6429 90.5473 48.4543 90.4961L9.83301 78.0828V74.2561C10.0293 74.2598 10.2242 74.2912 10.4117 74.3494L49.033 86.7441ZM103.166 65.8561V69.6828L93.049 72.9308C92.7104 73.0606 92.4225 73.2958 92.2276 73.6016C92.0327 73.9074 91.9411 74.2677 91.9663 74.6294C91.9743 76.2444 91.4585 77.8183 90.4962 79.1153C89.5339 80.4122 88.1771 81.3623 86.6292 81.8228C85.0814 82.2834 83.4259 82.2297 81.9111 81.6698C80.3963 81.1099 79.1039 80.074 78.2277 78.7174C78.0255 78.4596 77.746 78.2733 77.4302 78.186C77.1144 78.0986 76.7789 78.1148 76.473 78.2321L64.5263 82.0401C64.3475 82.1072 64.1573 82.1389 63.9663 82.1334V78.3068L75.3343 74.6668C76.4212 74.2932 77.6008 74.2882 78.6908 74.6527C79.7807 75.0171 80.7201 75.7306 81.3637 76.6828C81.6988 77.2106 82.1622 77.6449 82.7106 77.9452C83.2589 78.2455 83.8745 78.402 84.4997 78.4001C85.4889 78.3971 86.4368 78.0029 87.1363 77.3034C87.8358 76.6039 88.23 75.656 88.233 74.6668C88.2 73.5064 88.5392 72.3659 89.2008 71.412C89.8625 70.4582 90.8119 69.741 91.9103 69.3654L102.588 65.9494C102.775 65.8912 102.97 65.8598 103.166 65.8561Z"
                                                    fill="#3E3E3E"
                                                />
                                                <path
                                                    d="M56.5003 14.9333C56.0052 14.9333 55.5304 14.7367 55.1803 14.3866C54.8303 14.0365 54.6336 13.5617 54.6336 13.0667V1.86667C54.6336 1.3716 54.8303 0.896802 55.1803 0.546734C55.5304 0.196666 56.0052 0 56.5003 0C56.9953 0 57.4701 0.196666 57.8202 0.546734C58.1703 0.896802 58.3669 1.3716 58.3669 1.86667V13.0667C58.3669 13.5617 58.1703 14.0365 57.8202 14.3866C57.4701 14.7367 56.9953 14.9333 56.5003 14.9333ZM32.2336 18.6667C31.8851 18.6686 31.5431 18.5729 31.2462 18.3905C30.9493 18.208 30.7094 17.9461 30.5536 17.6344L24.9536 6.4344C24.7323 5.99131 24.6961 5.47846 24.8529 5.00867C25.0098 4.53888 25.3468 4.15063 25.7899 3.92933C26.233 3.70804 26.7458 3.67182 27.2156 3.82865C27.6854 3.98548 28.0737 4.32251 28.2949 4.7656L33.8949 15.9656C34.0368 16.2496 34.104 16.565 34.09 16.8821C34.0761 17.1993 33.9815 17.5076 33.8151 17.778C33.6488 18.0483 33.4163 18.2719 33.1396 18.4274C32.8629 18.5829 32.551 18.6652 32.2336 18.6667ZM80.7669 18.6667C80.4489 18.6665 80.1361 18.5851 79.8584 18.4301C79.5806 18.2751 79.3471 18.0517 79.1799 17.7811C79.0127 17.5105 78.9175 17.2017 78.9032 16.884C78.8889 16.5662 78.956 16.2501 79.0981 15.9656L84.6981 4.7656C84.9194 4.32251 85.3077 3.98548 85.7775 3.82865C86.2473 3.67182 86.7601 3.70804 87.2032 3.92933C87.6463 4.15063 87.9833 4.53888 88.1402 5.00867C88.297 5.47846 88.2608 5.99131 88.0395 6.4344L82.4395 17.6344C82.2843 17.945 82.0455 18.2061 81.7501 18.3885C81.4546 18.5708 81.1142 18.6672 80.7669 18.6667Z"
                                                    fill="#393939"
                                                />
                                            </svg>
                                            <p>{t("No Markets Found")}</p>
                                        </div>
                                    )}
                                    <div className="paginationmain">
                                        {!loadertable && pools?.length > 0 && (
                                            <Pagination>
                                                <Pagination.Prev
                                                    onClick={handlePrev}
                                                    disabled={currentPage === 1}
                                                >
                                                    <svg
                                                        width="12"
                                                        height="10"
                                                        viewBox="0 0 12 10"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="arrow"
                                                    >
                                                        <path
                                                            d="M0.137597 5.0194L4.35635 9.23815C4.4443 9.32611 4.5636 9.37552 4.68799 9.37552C4.81238 9.37552 4.93167 9.32611 5.01963 9.23815C5.10759 9.1502 5.157 9.0309 5.157 8.90651C5.157 8.78212 5.10759 8.66283 5.01963 8.57487L1.60068 5.15651L10.7817 5.15651C10.9061 5.15651 11.0253 5.10713 11.1132 5.01922C11.2011 4.93131 11.2505 4.81208 11.2505 4.68776C11.2505 4.56344 11.2011 4.44421 11.1132 4.3563C11.0253 4.2684 10.9061 4.21901 10.7817 4.21901L1.60068 4.21901L5.01963 0.800651C5.10759 0.712694 5.157 0.593399 5.157 0.46901C5.157 0.344621 5.10759 0.225326 5.01963 0.137369C4.93167 0.0494129 4.81238 -5.62838e-07 4.68799 -5.73712e-07C4.5636 -5.84586e-07 4.4443 0.0494129 4.35635 0.137369L0.137597 4.35612C0.0940147 4.39965 0.0594393 4.45135 0.0358501 4.50826C0.012261 4.56516 0.000119759 4.62616 0.000119753 4.68776C0.000119748 4.74936 0.012261 4.81036 0.0358501 4.86726C0.0594392 4.92417 0.0940147 4.97587 0.137597 5.0194Z"
                                                            fill="#494949"
                                                        />
                                                    </svg>
                                                </Pagination.Prev>

                                                {[...Array(totalPages)].map((_, index) => {
                                                    const page = index + 1;
                                                    return (
                                                        <Pagination.Item
                                                            key={page}
                                                            active={currentPage === page}
                                                            onClick={() => handlePageChange(page)}
                                                        >
                                                            {page}
                                                        </Pagination.Item>
                                                    );
                                                })}
                                                <Pagination.Next
                                                    onClick={handleNext}
                                                    disabled={currentPage === totalPages}
                                                >
                                                    <svg
                                                        width="12"
                                                        height="10"
                                                        viewBox="0 0 12 10"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="arrow"
                                                    >
                                                        <path
                                                            d="M11.1129 4.35612L6.89414 0.137367C6.80618 0.0494103 6.68689 -3.37512e-06 6.5625 -3.37512e-06C6.43811 -3.37512e-06 6.31882 0.0494103 6.23086 0.137367C6.1429 0.225323 6.09349 0.344618 6.09349 0.469008C6.09349 0.593397 6.1429 0.712692 6.23086 0.800649L9.6498 4.21901H0.46875C0.34443 4.21901 0.225201 4.26839 0.137294 4.3563C0.0493861 4.44421 0 4.56344 0 4.68776C0 4.81208 0.0493861 4.93131 0.137294 5.01921C0.225201 5.10712 0.34443 5.15651 0.46875 5.15651H9.6498L6.23086 8.57487C6.1429 8.66282 6.09349 8.78212 6.09349 8.90651C6.09349 9.0309 6.1429 9.15019 6.23086 9.23815C6.31882 9.32611 6.43811 9.37552 6.5625 9.37552C6.68689 9.37552 6.80618 9.32611 6.89414 9.23815L11.1129 5.0194C11.1565 4.97586 11.191 4.92417 11.2146 4.86726C11.2382 4.81036 11.2504 4.74936 11.2504 4.68776C11.2504 4.62616 11.2382 4.56516 11.2146 4.50825C11.191 4.45135 11.1565 4.39965 11.1129 4.35612Z"
                                                            fill="#494949"
                                                        />
                                                    </svg>
                                                </Pagination.Next>
                                            </Pagination>
                                        )}
                                    </div>
                                </div>
                            </Tab>
                            <Tab
                                eventKey="History"
                                title={t("History")}
                            >
                                <div className="inner-tab-content historycontentscroller">
                                    {pointsHistory?.filter(point =>
                                        point?.eventType === 'deposit' || point?.eventType === 'withdraw'
                                    ).length > 0 ? (
                                        pointsHistory.map((point, index) => {
                                            if (point?.eventType !== 'deposit' && point?.eventType !== 'withdraw') return null;
                                            return (
                                                <div className="inner-row" key={index}>
                                                    <div className="rowright w-100">
                                                        <div className="rowrightmain w-100">
                                                            <div className="rowrightinner w-25">
                                                                <p className="rowpara">Type</p>
                                                                <h6 className={point?.eventType === 'deposit' ? "depositpara" : "withdrawpara"}>
                                                                    {point?.eventType}
                                                                </h6>
                                                            </div>
                                                            <div className="rowrightinner w-25">
                                                                <p className="rowpara">Time</p>
                                                                <h6 className="rowrighthead">
                                                                    {formatDates(point?.createdAt)}{" "}
                                                                    <span className="grey">{formatTimeTo12Hour(point?.createdAt)}</span>
                                                                </h6>
                                                            </div>
                                                            <div className="rowrightinner w-25">
                                                                <p className="rowpara">Amount</p>
                                                                <h6 className="rowrighthead">{handleToFixedOnDecimals(point?.value)} USDT</h6>
                                                            </div>
                                                            <div className="rowrightinner w-25">
                                                                <p className="rowpara">TRX Hash</p>
                                                                <h6 className="rowrighthead">
                                                                    {point?.transactionHash ? getFormatedWeb3Address(point?.transactionHash, false) : '--'}
                                                                    <a
                                                                        href={`https://arbiscan.io/tx/${point?.transactionHash}`}
                                                                        className="innerlink"
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        {/* SVG icon */}
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                            <path
                                                                                d="M12.25 7.58333V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V2.91667C1.75 2.60725 1.87292 2.3105 2.09171 2.09171C2.3105 1.87292 2.60725 1.75 2.91667 1.75H6.41667"
                                                                                stroke="#727272"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                            <path
                                                                                d="M12.25 1.75L7 7"
                                                                                stroke="#727272"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                            <path
                                                                                d="M8.75 1.75H12.25V5.25"
                                                                                stroke="#727272"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                        </svg>
                                                                    </a>
                                                                </h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <div className="whennopolls">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="113"
                                                height="112"
                                                viewBox="0 0 113 112"
                                                fill="none"
                                            >
                                                <path
                                                    d="M110.633 39.2002V42.9335L56.4996 61.6002L2.36625 42.9335V39.2002C2.36383 38.801 2.48942 38.4116 2.7246 38.0891C2.95977 37.7666 3.29214 37.5279 3.67291 37.4082L54.6329 21.0375L55.9209 20.6269C56.2956 20.4961 56.7035 20.4961 57.0782 20.6269L58.3662 21.0375L109.326 37.4082C109.707 37.5279 110.039 37.7666 110.275 38.0891C110.51 38.4116 110.635 38.801 110.633 39.2002Z"
                                                    fill="#2F2F2F"
                                                />
                                                <path
                                                    d="M110.633 39.2002V89.0215C110.632 89.7987 110.389 90.5564 109.938 91.1888C109.486 91.8213 108.848 92.2969 108.113 92.5495L58.3662 109.704L57.7129 109.928C56.9283 110.208 56.0709 110.208 55.2862 109.928L54.6329 109.704L4.88625 92.5495C4.15123 92.2969 3.51338 91.8213 3.06164 91.1888C2.6099 90.5564 2.3668 89.7987 2.36625 89.0215V39.2002C2.36383 39.5993 2.48942 39.9888 2.7246 40.3113C2.95977 40.6338 3.29214 40.8725 3.67291 40.9922L54.7076 57.3815L55.9209 57.7735C56.2956 57.9043 56.7035 57.9043 57.0782 57.7735L58.2916 57.3815L109.326 40.9922C109.707 40.8725 110.039 40.6338 110.275 40.3113C110.51 39.9888 110.635 39.5993 110.633 39.2002Z"
                                                    fill="#353535"
                                                />
                                                <path
                                                    d="M49.033 64.7736V97.2536C49.0323 97.5517 48.9606 97.8454 48.8239 98.1103C48.6871 98.3753 48.4893 98.6039 48.2467 98.7772C48.004 98.9505 47.7237 99.0635 47.4287 99.1069C47.1337 99.1503 46.8326 99.1229 46.5504 99.0269L11.0837 86.8002C10.7164 86.6718 10.3985 86.4319 10.1742 86.114C9.94999 85.796 9.8307 85.4159 9.83304 85.0269V53.3682C9.83326 53.0736 9.90321 52.7832 10.0372 52.5208C10.1712 52.2584 10.3653 52.0314 10.6038 51.8585C10.8424 51.6855 11.1184 51.5714 11.4095 51.5256C11.7005 51.4798 11.9983 51.5036 12.2784 51.5949L47.745 62.9816C48.1205 63.1076 48.4468 63.3484 48.6779 63.6699C48.909 63.9915 49.0333 64.3776 49.033 64.7736ZM103.166 53.3682V85.0269C103.169 85.4159 103.049 85.796 102.825 86.114C102.601 86.4319 102.283 86.6718 101.916 86.8002L66.449 99.0269C66.1668 99.1229 65.8657 99.1503 65.5707 99.1069C65.2758 99.0635 64.9954 98.9505 64.7527 98.7772C64.5101 98.6039 64.3123 98.3753 64.1755 98.1103C64.0388 97.8454 63.9671 97.5517 63.9664 97.2536V64.7736C63.9661 64.3776 64.0904 63.9915 64.3215 63.6699C64.5526 63.3484 64.8789 63.1076 65.2544 62.9816L100.721 51.5949C101.001 51.5036 101.299 51.4798 101.59 51.5256C101.881 51.5714 102.157 51.6855 102.396 51.8585C102.634 52.0314 102.828 52.2584 102.962 52.5208C103.096 52.7832 103.166 53.0736 103.166 53.3682Z"
                                                    fill="#2F2F2F"
                                                />
                                                <path
                                                    d="M58.3671 21.0375V48.5335C58.3671 49.0286 58.1705 49.5034 57.8204 49.8535C57.4703 50.2035 56.9955 50.4002 56.5005 50.4002C56.0054 50.4002 55.5306 50.2035 55.1805 49.8535C54.8305 49.5034 54.6338 49.0286 54.6338 48.5335V21.0375L55.9218 20.6269C56.2965 20.4961 56.7044 20.4961 57.0791 20.6269L58.3671 21.0375Z"
                                                    fill="#3E3E3E"
                                                />
                                                <path
                                                    d="M58.3666 57.8667V109.704L57.7132 109.928C56.9286 110.208 56.0712 110.208 55.2866 109.928L54.6332 109.704V57.8667C54.6292 57.7018 54.6545 57.5374 54.7079 57.3813L55.9212 57.7733C56.2959 57.9041 56.7039 57.9041 57.0786 57.7733L58.2919 57.3813C58.3453 57.5374 58.3706 57.7018 58.3666 57.8667Z"
                                                    fill="#2F2F2F"
                                                />
                                                <path
                                                    d="M49.033 74.0881V77.9334C48.8368 77.9283 48.6422 77.8969 48.4543 77.8401L9.83301 65.4268V61.6001C10.0293 61.6038 10.2242 61.6352 10.4117 61.6934L49.033 74.0881ZM49.033 86.7441V90.5708C48.8376 90.5724 48.6429 90.5473 48.4543 90.4961L9.83301 78.0828V74.2561C10.0293 74.2598 10.2242 74.2912 10.4117 74.3494L49.033 86.7441ZM103.166 65.8561V69.6828L93.049 72.9308C92.7104 73.0606 92.4225 73.2958 92.2276 73.6016C92.0327 73.9074 91.9411 74.2677 91.9663 74.6294C91.9743 76.2444 91.4585 77.8183 90.4962 79.1153C89.5339 80.4122 88.1771 81.3623 86.6292 81.8228C85.0814 82.2834 83.4259 82.2297 81.9111 81.6698C80.3963 81.1099 79.1039 80.074 78.2277 78.7174C78.0255 78.4596 77.746 78.2733 77.4302 78.186C77.1144 78.0986 76.7789 78.1148 76.473 78.2321L64.5263 82.0401C64.3475 82.1072 64.1573 82.1389 63.9663 82.1334V78.3068L75.3343 74.6668C76.4212 74.2932 77.6008 74.2882 78.6908 74.6527C79.7807 75.0171 80.7201 75.7306 81.3637 76.6828C81.6988 77.2106 82.1622 77.6449 82.7106 77.9452C83.2589 78.2455 83.8745 78.402 84.4997 78.4001C85.4889 78.3971 86.4368 78.0029 87.1363 77.3034C87.8358 76.6039 88.23 75.656 88.233 74.6668C88.2 73.5064 88.5392 72.3659 89.2008 71.412C89.8625 70.4582 90.8119 69.741 91.9103 69.3654L102.588 65.9494C102.775 65.8912 102.97 65.8598 103.166 65.8561Z"
                                                    fill="#3E3E3E"
                                                />
                                                <path
                                                    d="M56.5003 14.9333C56.0052 14.9333 55.5304 14.7367 55.1803 14.3866C54.8303 14.0365 54.6336 13.5617 54.6336 13.0667V1.86667C54.6336 1.3716 54.8303 0.896802 55.1803 0.546734C55.5304 0.196666 56.0052 0 56.5003 0C56.9953 0 57.4701 0.196666 57.8202 0.546734C58.1703 0.896802 58.3669 1.3716 58.3669 1.86667V13.0667C58.3669 13.5617 58.1703 14.0365 57.8202 14.3866C57.4701 14.7367 56.9953 14.9333 56.5003 14.9333ZM32.2336 18.6667C31.8851 18.6686 31.5431 18.5729 31.2462 18.3905C30.9493 18.208 30.7094 17.9461 30.5536 17.6344L24.9536 6.4344C24.7323 5.99131 24.6961 5.47846 24.8529 5.00867C25.0098 4.53888 25.3468 4.15063 25.7899 3.92933C26.233 3.70804 26.7458 3.67182 27.2156 3.82865C27.6854 3.98548 28.0737 4.32251 28.2949 4.7656L33.8949 15.9656C34.0368 16.2496 34.104 16.565 34.09 16.8821C34.0761 17.1993 33.9815 17.5076 33.8151 17.778C33.6488 18.0483 33.4163 18.2719 33.1396 18.4274C32.8629 18.5829 32.551 18.6652 32.2336 18.6667ZM80.7669 18.6667C80.4489 18.6665 80.1361 18.5851 79.8584 18.4301C79.5806 18.2751 79.3471 18.0517 79.1799 17.7811C79.0127 17.5105 78.9175 17.2017 78.9032 16.884C78.8889 16.5662 78.956 16.2501 79.0981 15.9656L84.6981 4.7656C84.9194 4.32251 85.3077 3.98548 85.7775 3.82865C86.2473 3.67182 86.7601 3.70804 87.2032 3.92933C87.6463 4.15063 87.9833 4.53888 88.1402 5.00867C88.297 5.47846 88.2608 5.99131 88.0395 6.4344L82.4395 17.6344C82.2843 17.945 82.0455 18.2061 81.7501 18.3885C81.4546 18.5708 81.1142 18.6672 80.7669 18.6667Z"
                                                    fill="#393939"
                                                />
                                            </svg>
                                            <p>{t("No History Found")}</p>
                                        </div>
                                    )}

                                </div>
                            </Tab>
                            <Tab
                                eventKey="Points"
                                title={t("Raindrops Breakdown")}
                            >
                                <div className="inner-tab-content historycontentscroller">
                                    {pointsHistory && pointsHistory.length > 0 ? (
                                        pointsHistory.map((point, index) => (
                                            <div className="inner-row" key={index}>
                                                <div className="rowright w-100">
                                                    <div className="rowrightmain w-100">
                                                        <div className="rowrightinner w-25">
                                                            <p className="rowpara">{t("Action")}</p>
                                                            <h6 className="rowrighthead" style={{ textTransform: "capitalize" }}>{getPointsTitle[point?.eventType]}</h6>
                                                        </div>
                                                        <div className="rowrightinner w-25">
                                                            <p className="rowpara">{t("Date")}</p>
                                                            <h6 className="rowrighthead">{formatDates(point?.createdAt)}</h6>
                                                        </div>
                                                        <div className="rowrightinner w-25">
                                                            <p className="rowpara">{t("Amount")} {point?.token?.tokenSymbol === TOKEN_RAIN ? TOKEN_RAIN : TOKEN_USDT}</p>
                                                            <h6 className="rowrighthead">{getTokenSymbol(point?.token?.tokenSymbol)}{point?.value > 0 ? `${handleToFixedOnDecimals(point?.value)}` : "--"}</h6>
                                                        </div>
                                                        <div className="rowrightinner w-25">
                                                            <p className="rowpara">{t("Raindrops Earned")}</p>
                                                            <h6
                                                                className="rowrighthead"
                                                                style={{ color: point?.eventType === 'withdraw' ? 'var(--logout-text)' : 'var(--green-text)' }}
                                                            >
                                                                {handleToFixedOnDecimals(point?.points)} Raindrops
                                                            </h6>
                                                        </div>
                                                        <div className="rowrightinner w-25">
                                                            <p className="rowpara">{t("Notes")}</p>
                                                            <h6 className="rowrighthead" >{getPointsRatio[point?.eventType]}</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="whennopolls">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="113"
                                                height="112"
                                                viewBox="0 0 113 112"
                                                fill="none"
                                            >
                                                <path
                                                    d="M110.633 39.2002V42.9335L56.4996 61.6002L2.36625 42.9335V39.2002C2.36383 38.801 2.48942 38.4116 2.7246 38.0891C2.95977 37.7666 3.29214 37.5279 3.67291 37.4082L54.6329 21.0375L55.9209 20.6269C56.2956 20.4961 56.7035 20.4961 57.0782 20.6269L58.3662 21.0375L109.326 37.4082C109.707 37.5279 110.039 37.7666 110.275 38.0891C110.51 38.4116 110.635 38.801 110.633 39.2002Z"
                                                    fill="#2F2F2F"
                                                />
                                                <path
                                                    d="M110.633 39.2002V89.0215C110.632 89.7987 110.389 90.5564 109.938 91.1888C109.486 91.8213 108.848 92.2969 108.113 92.5495L58.3662 109.704L57.7129 109.928C56.9283 110.208 56.0709 110.208 55.2862 109.928L54.6329 109.704L4.88625 92.5495C4.15123 92.2969 3.51338 91.8213 3.06164 91.1888C2.6099 90.5564 2.3668 89.7987 2.36625 89.0215V39.2002C2.36383 39.5993 2.48942 39.9888 2.7246 40.3113C2.95977 40.6338 3.29214 40.8725 3.67291 40.9922L54.7076 57.3815L55.9209 57.7735C56.2956 57.9043 56.7035 57.9043 57.0782 57.7735L58.2916 57.3815L109.326 40.9922C109.707 40.8725 110.039 40.6338 110.275 40.3113C110.51 39.9888 110.635 39.5993 110.633 39.2002Z"
                                                    fill="#353535"
                                                />
                                                <path
                                                    d="M49.033 64.7736V97.2536C49.0323 97.5517 48.9606 97.8454 48.8239 98.1103C48.6871 98.3753 48.4893 98.6039 48.2467 98.7772C48.004 98.9505 47.7237 99.0635 47.4287 99.1069C47.1337 99.1503 46.8326 99.1229 46.5504 99.0269L11.0837 86.8002C10.7164 86.6718 10.3985 86.4319 10.1742 86.114C9.94999 85.796 9.8307 85.4159 9.83304 85.0269V53.3682C9.83326 53.0736 9.90321 52.7832 10.0372 52.5208C10.1712 52.2584 10.3653 52.0314 10.6038 51.8585C10.8424 51.6855 11.1184 51.5714 11.4095 51.5256C11.7005 51.4798 11.9983 51.5036 12.2784 51.5949L47.745 62.9816C48.1205 63.1076 48.4468 63.3484 48.6779 63.6699C48.909 63.9915 49.0333 64.3776 49.033 64.7736ZM103.166 53.3682V85.0269C103.169 85.4159 103.049 85.796 102.825 86.114C102.601 86.4319 102.283 86.6718 101.916 86.8002L66.449 99.0269C66.1668 99.1229 65.8657 99.1503 65.5707 99.1069C65.2758 99.0635 64.9954 98.9505 64.7527 98.7772C64.5101 98.6039 64.3123 98.3753 64.1755 98.1103C64.0388 97.8454 63.9671 97.5517 63.9664 97.2536V64.7736C63.9661 64.3776 64.0904 63.9915 64.3215 63.6699C64.5526 63.3484 64.8789 63.1076 65.2544 62.9816L100.721 51.5949C101.001 51.5036 101.299 51.4798 101.59 51.5256C101.881 51.5714 102.157 51.6855 102.396 51.8585C102.634 52.0314 102.828 52.2584 102.962 52.5208C103.096 52.7832 103.166 53.0736 103.166 53.3682Z"
                                                    fill="#2F2F2F"
                                                />
                                                <path
                                                    d="M58.3671 21.0375V48.5335C58.3671 49.0286 58.1705 49.5034 57.8204 49.8535C57.4703 50.2035 56.9955 50.4002 56.5005 50.4002C56.0054 50.4002 55.5306 50.2035 55.1805 49.8535C54.8305 49.5034 54.6338 49.0286 54.6338 48.5335V21.0375L55.9218 20.6269C56.2965 20.4961 56.7044 20.4961 57.0791 20.6269L58.3671 21.0375Z"
                                                    fill="#3E3E3E"
                                                />
                                                <path
                                                    d="M58.3666 57.8667V109.704L57.7132 109.928C56.9286 110.208 56.0712 110.208 55.2866 109.928L54.6332 109.704V57.8667C54.6292 57.7018 54.6545 57.5374 54.7079 57.3813L55.9212 57.7733C56.2959 57.9041 56.7039 57.9041 57.0786 57.7733L58.2919 57.3813C58.3453 57.5374 58.3706 57.7018 58.3666 57.8667Z"
                                                    fill="#2F2F2F"
                                                />
                                                <path
                                                    d="M49.033 74.0881V77.9334C48.8368 77.9283 48.6422 77.8969 48.4543 77.8401L9.83301 65.4268V61.6001C10.0293 61.6038 10.2242 61.6352 10.4117 61.6934L49.033 74.0881ZM49.033 86.7441V90.5708C48.8376 90.5724 48.6429 90.5473 48.4543 90.4961L9.83301 78.0828V74.2561C10.0293 74.2598 10.2242 74.2912 10.4117 74.3494L49.033 86.7441ZM103.166 65.8561V69.6828L93.049 72.9308C92.7104 73.0606 92.4225 73.2958 92.2276 73.6016C92.0327 73.9074 91.9411 74.2677 91.9663 74.6294C91.9743 76.2444 91.4585 77.8183 90.4962 79.1153C89.5339 80.4122 88.1771 81.3623 86.6292 81.8228C85.0814 82.2834 83.4259 82.2297 81.9111 81.6698C80.3963 81.1099 79.1039 80.074 78.2277 78.7174C78.0255 78.4596 77.746 78.2733 77.4302 78.186C77.1144 78.0986 76.7789 78.1148 76.473 78.2321L64.5263 82.0401C64.3475 82.1072 64.1573 82.1389 63.9663 82.1334V78.3068L75.3343 74.6668C76.4212 74.2932 77.6008 74.2882 78.6908 74.6527C79.7807 75.0171 80.7201 75.7306 81.3637 76.6828C81.6988 77.2106 82.1622 77.6449 82.7106 77.9452C83.2589 78.2455 83.8745 78.402 84.4997 78.4001C85.4889 78.3971 86.4368 78.0029 87.1363 77.3034C87.8358 76.6039 88.23 75.656 88.233 74.6668C88.2 73.5064 88.5392 72.3659 89.2008 71.412C89.8625 70.4582 90.8119 69.741 91.9103 69.3654L102.588 65.9494C102.775 65.8912 102.97 65.8598 103.166 65.8561Z"
                                                    fill="#3E3E3E"
                                                />
                                                <path
                                                    d="M56.5003 14.9333C56.0052 14.9333 55.5304 14.7367 55.1803 14.3866C54.8303 14.0365 54.6336 13.5617 54.6336 13.0667V1.86667C54.6336 1.3716 54.8303 0.896802 55.1803 0.546734C55.5304 0.196666 56.0052 0 56.5003 0C56.9953 0 57.4701 0.196666 57.8202 0.546734C58.1703 0.896802 58.3669 1.3716 58.3669 1.86667V13.0667C58.3669 13.5617 58.1703 14.0365 57.8202 14.3866C57.4701 14.7367 56.9953 14.9333 56.5003 14.9333ZM32.2336 18.6667C31.8851 18.6686 31.5431 18.5729 31.2462 18.3905C30.9493 18.208 30.7094 17.9461 30.5536 17.6344L24.9536 6.4344C24.7323 5.99131 24.6961 5.47846 24.8529 5.00867C25.0098 4.53888 25.3468 4.15063 25.7899 3.92933C26.233 3.70804 26.7458 3.67182 27.2156 3.82865C27.6854 3.98548 28.0737 4.32251 28.2949 4.7656L33.8949 15.9656C34.0368 16.2496 34.104 16.565 34.09 16.8821C34.0761 17.1993 33.9815 17.5076 33.8151 17.778C33.6488 18.0483 33.4163 18.2719 33.1396 18.4274C32.8629 18.5829 32.551 18.6652 32.2336 18.6667ZM80.7669 18.6667C80.4489 18.6665 80.1361 18.5851 79.8584 18.4301C79.5806 18.2751 79.3471 18.0517 79.1799 17.7811C79.0127 17.5105 78.9175 17.2017 78.9032 16.884C78.8889 16.5662 78.956 16.2501 79.0981 15.9656L84.6981 4.7656C84.9194 4.32251 85.3077 3.98548 85.7775 3.82865C86.2473 3.67182 86.7601 3.70804 87.2032 3.92933C87.6463 4.15063 87.9833 4.53888 88.1402 5.00867C88.297 5.47846 88.2608 5.99131 88.0395 6.4344L82.4395 17.6344C82.2843 17.945 82.0455 18.2061 81.7501 18.3885C81.4546 18.5708 81.1142 18.6672 80.7669 18.6667Z"
                                                    fill="#393939"
                                                />
                                            </svg>
                                            <p>{t("No History Found")}</p>
                                        </div>
                                    )}

                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </section>

            <Modal className="detail" show={show3} onHide={handleClose3} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t("Select Winner")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="upper-heading">
                        <h5>{t("Question")}</h5>
                        <p>{poolsdetail?.question}</p>
                    </div>
                    <div className="uppercontent">
                        <div className="mainboxxx">
                            {poolsdetail?.options?.map((option, index) => {
                                const totalSupplyLP =
                                    percentageindiv && percentageindiv[index]
                                        ? parseFloat(percentageindiv[index])
                                        : 0;
                                const divisionResult =
                                    totalSupplyLP && totalSupplyLP !== 0
                                        ? ((totalSupplyLP / percentageoption) * 100).toFixed(2)
                                        : "0";
                                return (
                                    <div
                                        key={option._id}
                                        className={`innermainbox ${selectedOption === option.choiceIndex ? "active" : ""
                                            }`}
                                        onClick={() =>
                                            handleOptionClick(option.choiceIndex, option?.optionName)
                                        }
                                    >
                                        <div className="left">
                                            <h6>{option.optionName}</h6>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <p style={{ color: "white" }}>{`Estimated ${NETWORK_FEES} $${gasEstimateInUsdt ? parseFloat(gasEstimateInUsdt)?.toFixed(4) : "0"}`}</p>
                    </div>
                    <div className="lastbutton">
                        <button
                            onClick={() =>
                                handleContinue(poolsdetail?.contractAddress, poolsdetail?._id)
                            }
                        >
                            {t("Continue")}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal className="detail" show={show5} onHide={handleClose5} centered>
                <Modal.Body>
                    <div className="innercontent">
                        <div className="upperimg">
                            <img
                                src="\assets\greentick.png"
                                alt="img"
                                className="img-fluid tickimg"
                            />
                        </div>
                        <h2 className="upperheading">{t("Winner Successfully Decided")}</h2>
                        <div className="winner-area">
                            <p>{t("Winner")}</p>
                            <h4>{selectedname}</h4>
                        </div>
                        <button
                            className="ok"
                            onClick={() => {
                                handleClose5();
                            }}
                        >
                            {t("OK")}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal className="detail" show={show6} onHide={handleClose6} centered>
                <Modal.Body>
                    <div className="innercontent">
                        <div className="upperimg">
                            <img
                                src="\assets\greentick.png"
                                alt="img"
                                className="img-fluid tickimg"
                            />
                        </div>
                        <h2 className="upperheading">{t("Market Closed")}</h2>
                        <button
                            className="ok"
                            onClick={() => {
                                handleClose6();
                            }}
                        >
                            {t("OK")}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                className="detail editprofile-modal"
                show={show1}
                onHide={handleClose1}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{t("Edit Profile")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="profile-content">
                        <div className="main-profile">
                            <div className="main-img">
                                <img
                                    src={profilepic || userprofile?.profilePic}
                                    alt="Profile"
                                    className="img-fluid"
                                />
                            </div>
                            <div className="profile-detail">
                                <h6>{t("Profile Image")}</h6>
                                <p>
                                    {t(
                                        "We recommend uploading images in 400x400 resolution. Max 5 MB in JPEG or PNG format"
                                    )}
                                </p>
                                <div className="twice-btns">
                                    <label htmlFor="upload" className="btn-upload">
                                        {t("Change")}
                                    </label>
                                    <a
                                        href="#"
                                        className="btn-remove"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleRemove();
                                        }}
                                    >
                                        {t("Remove")}
                                    </a>
                                </div>
                                <input
                                    type="file"
                                    className="d-none"
                                    id="upload"
                                    onChange={handleFileChange}
                                />
                            </div>
                        </div>
                        <div className="option-field">
                            <label>{t("Full Name")}</label>
                            <input
                                type="text"
                                placeholder={t("Full Name")}
                                value={name}
                                onChange={(e) => {
                                    if (e.target.value.length <= 25) {
                                        setName(e.target.value);
                                    }
                                }}
                                maxLength={25}
                            />
                            <label className="mt-1">{name?.length}/25</label>
                        </div>
                        <div className="option-field">
                            <label>{t("Wallet Address")}</label>
                            <div className="inside-parent">
                                <input
                                    type="text"
                                    value={getFormatedWeb3Address(smartAccount, true)}
                                    placeholder={t("Wallet Address")}
                                    readOnly
                                />
                                <a onClick={() => handleCopyClick11(smartAccount, true)}>
                                    {isCopied ? (
                                        <p className="text-white">{t("copied")}</p>
                                    ) : (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="12"
                                            height="12"
                                            viewBox="0 0 12 12"
                                            fill="none"
                                        >
                                            <g clip-path="url(#clip0_635_6509)">
                                                <path
                                                    d="M10.0005 4H5.00049C4.4482 4 4.00049 4.44772 4.00049 5V10C4.00049 10.5523 4.4482 11 5.00049 11H10.0005C10.5528 11 11.0005 10.5523 11.0005 10V5C11.0005 4.44772 10.5528 4 10.0005 4Z"
                                                    stroke="#E6FF00"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M2.00049 8C1.45049 8 1.00049 7.55 1.00049 7V2C1.00049 1.45 1.45049 1 2.00049 1H7.00049C7.55049 1 8.00049 1.45 8.00049 2"
                                                    stroke="#E6FF00"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_635_6509">
                                                    <rect width="12" height="12" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    )}
                                </a>
                            </div>
                        </div>
                        <div className="option-field">
                            <label>{t("Twitter Account (Url)")}</label>
                            <input
                                type="text"
                                placeholder={t("Twitter Account")}
                                value={twitterUrl}
                                onChange={(e) => setTwitterUrl(e.target.value)}
                            />
                        </div>
                        <div className="option-field">
                            <label>{t("Telegram (Url)")}</label>
                            <input
                                type="text"
                                placeholder={t("Telegram")}
                                value={telegramUrl}
                                onChange={(e) => setTelegramUrl(e.target.value)}
                            />
                        </div>
                        <div className="option-field">
                            <label>{t("Discord (Url)")}</label>
                            <input
                                type="text"
                                placeholder={t("Discord")}
                                value={DiscordUrl}
                                onChange={(e) => setDiscordUrl(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="twice-btns">
                        <a onClick={handleClose1} className="btn-cancel">
                            {t("Cancel")}
                        </a>
                        <a onClick={() => handleUpdateProfile()} className="btn-save">
                            {t("Save")}
                        </a>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                className="round"
                show={show7}
                onHide={handleClose7}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Body style={{ padding: "28px 22px" }}>

                    <div className='maincontent'>
                        <div className='mainimage'>
                            <img src='\assets\round.png' alt='img' className='img-fluid round round-moving-animation' />
                        </div>
                        <h4>{message}</h4>
                        <p className='paraplacing'>Transaction in progress! <br /> Blockchain validation is underway. This may take a few moments.</p>
                        <ProgressiveProgressBar active={startProgressBar} />
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                className="detail changeresolver-modal"
                show={show8}
                onHide={handleClose8}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{t("Change Resolver")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="innercontent">
                        <div className="upperimg">
                            <img
                                src="\assets\changeresovler.svg"
                                alt="img"
                                className="img-fluid tickimg"
                            />
                        </div>
                        <h2 className="upperheading">{t("Are you sure")}?</h2>
                        <p className="para">
                            {t("You want to change resolver? This is irreversible")}
                        </p>
                        <div className="twice-btns">
                            <a onClick={handleClose8} className="btn-cancel">
                                {t("Cancel")}
                            </a>
                            <a className="btn-save">{t("Yes i’m Sure")}</a>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                className="detail changeresolver-modal"
                show={show9}
                onHide={handleClose9}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{t("Change Resolver")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="innercontent">
                        <label>{t("Enter Resolver Wallet Address")}</label>
                        <div className="option-field">
                            <input
                                type="text"
                                placeholder={t("Enter Wallet Address here...")}
                            />
                        </div>
                        <div className="twice-btns">
                            <a onClick={handleClose8} className="btn-cancel">
                                {t("Cancel")}
                            </a>
                            <a className="btn-save">{t("Change Resolver")}</a>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            
            <Modal className='common-modal-style withdrawmodal' show={showWithdraw} onHide={handleCloseWithdraw} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t("Withdraw")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='innercontent'>
                        <div className='upperbox'>
                            <p className='upperpara'><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM10 16.875C8.64026 16.875 7.31105 16.4718 6.18046 15.7164C5.04987 14.9609 4.16868 13.8872 3.64833 12.6309C3.12798 11.3747 2.99183 9.99237 3.2571 8.65875C3.52238 7.32513 4.17716 6.10013 5.13864 5.13864C6.10013 4.17716 7.32514 3.52237 8.65876 3.2571C9.99238 2.99183 11.3747 3.12798 12.631 3.64833C13.8872 4.16868 14.9609 5.04987 15.7164 6.18045C16.4718 7.31104 16.875 8.64025 16.875 10C16.8729 11.8227 16.1479 13.5702 14.8591 14.8591C13.5702 16.1479 11.8227 16.8729 10 16.875ZM11.25 13.75C11.25 13.9158 11.1842 14.0747 11.0669 14.1919C10.9497 14.3092 10.7908 14.375 10.625 14.375C10.2935 14.375 9.97554 14.2433 9.74112 14.0089C9.5067 13.7745 9.375 13.4565 9.375 13.125V10C9.20924 10 9.05027 9.93415 8.93306 9.81694C8.81585 9.69973 8.75 9.54076 8.75 9.375C8.75 9.20924 8.81585 9.05027 8.93306 8.93306C9.05027 8.81585 9.20924 8.75 9.375 8.75C9.70652 8.75 10.0245 8.8817 10.2589 9.11612C10.4933 9.35054 10.625 9.66848 10.625 10V13.125C10.7908 13.125 10.9497 13.1908 11.0669 13.3081C11.1842 13.4253 11.25 13.5842 11.25 13.75ZM8.75 6.5625C8.75 6.37708 8.80499 6.19582 8.908 6.04165C9.01101 5.88748 9.15743 5.76732 9.32874 5.69636C9.50004 5.62541 9.68854 5.60684 9.8704 5.64301C10.0523 5.67919 10.2193 5.76848 10.3504 5.89959C10.4815 6.0307 10.5708 6.19775 10.607 6.3796C10.6432 6.56146 10.6246 6.74996 10.5536 6.92127C10.4827 7.09257 10.3625 7.23899 10.2084 7.342C10.0542 7.44502 9.87292 7.5 9.6875 7.5C9.43886 7.5 9.20041 7.40123 9.02459 7.22541C8.84878 7.0496 8.75 6.81114 8.75 6.5625Z" fill="#E27625" />
                            </svg>{t("Only send to a USD  address on the Arbitrum network")}</p>
                        </div>
                        <div className="mainboxes">
                            <div className="innermainbox">
                                <p className="innerpara">{t("Token")}</p>
                                <div class="dropdown dropdowntokenitems">
                                    <button class="dropdown-toggle" >
                                        <div className="left-item">
                                            <img src={withdrawalTokenImage} alt="img" className="img-fluid" />
                                            {getTokenLabel(withdrawalToken)}
                                        </div>
                                    </button>
                                </div>
                            </div>
                            <div className="innermainbox">
                                <p className="innerpara">{t("Chain")}</p>
                                <div className="innerbox">
                                    <div className="tokenimg">
                                        <img src="/assets/navbar/arbitrum.svg" alt="innertokenimg" className="innertokenimg" />
                                    </div>
                                    <p className="tokenpara">{t("Arbitrum")}</p>
                                </div>
                            </div>
                        </div>
                        <div className='parentinputs'>
                            <div className='innerinput'>
                                <p className='inputpara'>{t("Address")}</p>
                                <div className='maxbtnparent'>     <input value={withdrawalAddress} onChange={(e) => setWithdrawalAddress(e.target.value)} type='text' placeholder='0x...' /></div>

                            </div>
                            <div className='innerinput'>
                                <div className='upperhead'>
                                    <div className='left'>
                                        <p className='inputpara'>{t("Amount")}</p>
                                    </div>
                                    <div className='right'>
                                        <p>{t("Balance")}:</p>
                                        {withdrawalToken === TOKEN_USDR ? <p className='text'>   <img src="/assets/poll/usdr.svg" alt="USD" className="img-fluid" style={{ width: "17px", marginRight: "4px" }} />
                                            {smartAccountUsdtBalance ? handleToFixedOnDecimals(smartAccountUsdtBalance) : "-"} USD</p> : <p className='text'>    <img src="/assets/navbar/arbitrum.svg" alt="img" className="img-fluid" /> </p>}

                                    </div>
                                </div>
                                <div className='maxbtnparent'>
                                    <input value={withdrawalAmount} onChange={(e) => setWithdrawalAmount(e.target.value)} type='number' placeholder='0.00' />
                                    <button onClick={() => withdrawalToken === TOKEN_USDR && setWithdrawalAmount(handleToFixedOnDecimals(smartAccountUsdtBalance))} className='max'>{t("MAX")}</button>
                                </div>
                            </div>
                        </div>
                        {withdrawalToken === TOKEN_USDR && IS_USDT_CONVERSION_ENABLED && (
                            <div className='upperbox'>
                                <p className='upperpara'>
                                    {+withdrawalAmount > 0 && isEthereumWalletAddress(withdrawalAddress)
                                        ? t("USD withdrawals are converted to USDT. You will receive {{amount}} USDT at this address.", { amount: withdrawalAmount })
                                        : t("USD withdrawals are converted to USDT. You will receive USDT at the destination address.")}
                                </p>
                            </div>
                        )}
                        <div className='lastbuttons'>
                            <button className='close' onClick={() => {
                                handleCloseWithdraw();
                            }}>{t("Close")}</button>
                            <button disabled={withdrawalRequest || !withdrawalAddress || !withdrawalAmount || withdrawalAmount === "0"} className='deposit' onClick={() => {
                                handleWithdrawFunds();
                            }}>{withdrawalRequest ? <span className="spinner" /> : t("Withdraw")}</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className='common-modal-style withdrawmodal' show={showFailed} onHide={handleCloseFailed} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t("Error")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='innercontent'>
                        <div className='uppermain'>
                            <div className='mainimg'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="37" height="38" viewBox="0 0 37 38" fill="none">
                                    <path d="M18.4997 34.4166C27.0141 34.4166 33.9163 27.5143 33.9163 18.9999C33.9163 10.4855 27.0141 3.58325 18.4997 3.58325C9.98528 3.58325 3.08301 10.4855 3.08301 18.9999C3.08301 27.5143 9.98528 34.4166 18.4997 34.4166Z" stroke="#522B0E" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M18.5 9.75V19L24.6667 22.0833" stroke="#522B0E" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <h6>{t("Withdrawal Failed")}</h6>
                            <p className='paraerror'>{t("There are a lot of withdrawals happening right now and yours was unsuccessful due to high congestion. Please try again later or break your withdrawal down into smaller chunks of")} {getTokenLabel(withdrawalToken)}</p>
                            <span className="importantnote">
                                {t("Note: Your")} {getTokenLabel(withdrawalToken)} {t("is safe this congestion should subside shortly.")}
                            </span>
                            <button className='back' onClick={() => {
                                handleCloseFailed();
                                handleShowWithdraw();
                            }}>{t("Back")}</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className='common-modal-style withdrawmodal' show={showComplete} onHide={handleCloseComplete} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t("Success")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='innercontent'>
                        <div className='uppermain'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="65" viewBox="0 0 64 65" fill="none" className='clock'>
                                <rect y="0.5" width="64" height="64" rx="32" fill="#99FF80" />
                                <path d="M48.9056 24.4461L28.4256 44.9261C28.3067 45.0451 28.1656 45.1395 28.0102 45.2039C27.8548 45.2683 27.6882 45.3015 27.52 45.3015C27.3518 45.3015 27.1852 45.2683 27.0298 45.2039C26.8745 45.1395 26.7333 45.0451 26.6144 44.9261L17.6544 35.9661C17.4142 35.7259 17.2793 35.4001 17.2793 35.0605C17.2793 34.7208 17.4142 34.3951 17.6544 34.1549C17.8946 33.9147 18.2203 33.7798 18.56 33.7798C18.8997 33.7798 19.2254 33.9147 19.4656 34.1549L27.52 42.2109L47.0944 22.6349C47.3346 22.3947 47.6603 22.2598 48 22.2598C48.3397 22.2598 48.6654 22.3947 48.9056 22.6349C49.1458 22.8751 49.2807 23.2008 49.2807 23.5405C49.2807 23.8801 49.1458 24.2059 48.9056 24.4461Z" fill="#111111" />
                            </svg>
                            <h6>{t("Withdrawal Completed!")}</h6>
                            <p className='paraaaa'>{t("Your funds")}<span> ({handleToFixedOnDecimals(withdrawalAmount)} {getTokenLabel(withdrawalToken)}) </span> {t("were successfully transferred")}</p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Offcanvas placement="bottom" className="tooltipoffcanvas" show={show} onHide={handleClose}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        RAIN Points
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <p>Raindrops reflect your economic contribution to the platform.</p>
                    <ul>
                        <li>100 Raindrops = $1 in value</li>
                        <li>Earn Raindrops by depositing funds, trading, adding liquidity, and inviting friends</li>
                        <li> Raindrops increase your share in airdrops and Raindrops</li>
                    </ul>
                </Offcanvas.Body>
            </Offcanvas>
            <SolvencyLimitModal show={showSolvencyModal} onHide={() => setShowSolvencyModal(false)} />
        </>
    );
};

export default PointsBreakdown;
